package com.raouf.mehrguard.web.i18n

internal val FrenchStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "Détecteur de QRishing Kotlin Multiplateforme",
    WebStringKey.MenuMain to "Menu principal",
    WebStringKey.MenuSecurity to "Sécurité",
    WebStringKey.MenuSystem to "Système",
    WebStringKey.NavDashboard to "Tableau de bord",
    WebStringKey.NavScanMonitor to "Moniteur de scan",
    WebStringKey.NavScanHistory to "Historique des scans",
    WebStringKey.NavTrustCentre to "Centre de confiance",
    WebStringKey.NavReports to "Rapports",
    WebStringKey.NavTraining to "Formation",
    WebStringKey.NavSettings to "Paramètres",
    WebStringKey.QuickActions to "Actions Rapides",

    // Hero Section
    WebStringKey.HeroTagline to "Sécurisé. Hors ligne.",
    WebStringKey.HeroTagline2 to "Défense Explicable.",
    WebStringKey.HeroDescription to "Mehr Guard analyse les menaces potentielles directement sur votre matériel. Profitez d'une protection sans latence.",
    
    // Dashboard
    WebStringKey.StartScan to "Démarrer un nouveau scan",
    WebStringKey.ImportImage to "Importer une image",
    WebStringKey.ScanQrCode to "Scanner le Code QR",
    WebStringKey.SystemHealth to "Santé du système",
    WebStringKey.ThreatDatabase to "Base de menaces",
    WebStringKey.Current to "Actuel",
    WebStringKey.Active to "Actif",
    WebStringKey.Threats to "Menaces",
    WebStringKey.SafeScans to "Scans sûrs",
    WebStringKey.EngineActive to "Moteur actif",
    WebStringKey.EnterpriseProtection to "Protection entreprise active",
    WebStringKey.SystemOptimal to "Système Optimal",
    WebStringKey.EngineStatus to "Moteur v2.4 • Mis à jour il y a 2h",
    WebStringKey.ThreatsBlocked to "Menaces Bloquées",
    WebStringKey.AllSystemsOperational to "Tous les systèmes opérationnels",

    // Dashboard Sections
    WebStringKey.SectionOverview to "Aperçu",
    WebStringKey.SectionSecurity to "Sécurité",
    WebStringKey.SectionTraining to "Formation",
    WebStringKey.SectionReports to "Rapports",
    WebStringKey.OfflineReady to "Prêt hors ligne",
    WebStringKey.OfflineDescription to "Base de données locale v2.4.1 active. Aucune donnée ne quitte cet appareil.",
    
    // Trust Centre
    WebStringKey.TrustCentreTitle to "Centre de Confiance",
    WebStringKey.OfflineGuarantee to "Garantie Hors Ligne Stricte",
    WebStringKey.OfflineGuaranteeDesc to "L'analyse Mehr Guard s'exécute entièrement sur le Neural Engine de votre appareil. Les données URL ne quittent jamais votre téléphone.",
    WebStringKey.ThreatSensitivity to "Sensibilité aux Menaces",
    WebStringKey.ResetConfirm to "Cela réinitialisera tous les paramètres du Centre de Confiance aux valeurs par défaut.",
    
    // Settings Quick Actions
    WebStringKey.ThreatMonitor to "Moniteur de Menaces",
    WebStringKey.ThreatMonitorDesc to "Voir les menaces en direct et exécuter un audit de sécurité",
    WebStringKey.TrustCentreDesc to "Paramètres de confidentialité et sensibilité aux menaces",
    WebStringKey.ExportReport to "Exporter le Rapport",
    WebStringKey.ExportReportDesc to "Générer un rapport de sécurité PDF ou JSON",

    // Dashboard Content
    WebStringKey.Analyze to "Analyser",
    WebStringKey.HeuristicEngine to "Moteur Heuristique",
    WebStringKey.HighPerformanceEngine to "Moteur Haute Performance",
    WebStringKey.RecentScans to "Scans Récents",
    WebStringKey.ViewFullHistory to "Voir l'Historique Complet",
    WebStringKey.Status to "Statut",
    WebStringKey.Source to "Provenance",
    WebStringKey.Details to "Détails",
    WebStringKey.Time to "Heure",
    WebStringKey.Version to "Édition",
    WebStringKey.LastUpdate to "Dernière Mise à Jour",
    WebStringKey.Signatures to "Empreintes",
    WebStringKey.CheckForUpdates to "Vérifier les mises à jour",
    WebStringKey.FeatureOfflineTitle to "Architecture Hors Ligne",
    WebStringKey.FeatureOfflineDesc to "L'analyse complète est effectuée localement. Votre flux de caméra et les données scannées ne touchent jamais un serveur externe, garantissant une confidentialité absolue.",
    WebStringKey.FeatureExplainableTitle to "Sécurité Explicable",
    WebStringKey.FeatureExplainableDesc to "Ne recevez pas juste un \"Blocage\". Nous fournissons des détails heuristiques sur les paramètres URL, les redirections et les charges utiles Javascript.",
    WebStringKey.FeaturePerformanceDesc to "Optimisé pour les environnements de bureau. Les scans sont traités en moins de 5 ms grâce aux binaires natifs Kotlin Multiplatform.",
    WebStringKey.TrainingCentre to "Centre de Formation",
    WebStringKey.LearnHomograph to "Apprenez à identifier les attaques homographes QR avancées.",
    WebStringKey.BeatTheBotAction to "Battre le Bot →",
    WebStringKey.NoScansYet to "Aucun scan pour le moment. Lancez un nouveau scan pour voir les résultats ici.",
    WebStringKey.VerdictSafe to "SÛR",
    WebStringKey.VerdictPhish to "PHISHING",
    WebStringKey.VerdictWarn to "ATTTENTION",
    WebStringKey.ScoreLabel to "Score :",

    // Scanner
    WebStringKey.ActiveScanner to "Scanner Actif",
    WebStringKey.OfflineMode to "Mode Hors Ligne",
    WebStringKey.LiveFeedDisconnected to "FLUX EN DIRECT DÉCONNECTÉ",
    WebStringKey.CameraAccessRequired to "Accès Caméra Requis",
    WebStringKey.CameraAccessDescription to "Glissez une image de code QR ici ou activez l'accès à la caméra pour commencer à scanner.",
    WebStringKey.EnableCamera to "Activer Caméra",
    WebStringKey.Scanning to "Scan en cours...",
    WebStringKey.ScanHint to "Maintenez stable. Analysé hors ligne en <5ms.",
    WebStringKey.Torch to "Torche",
    WebStringKey.Gallery to "Galerie",
    WebStringKey.PasteUrl to "Coller URL",
    WebStringKey.PasteUrlTitle to "Coller URL à Analyser",
    WebStringKey.AnalyzeUrl to "Analyser URL",
    WebStringKey.SystemStatus to "État du Système",
    WebStringKey.PhishingEngine to "Moteur Phishing",
    WebStringKey.Ready to "PRÊT",
    WebStringKey.LocalDb to "Base Locale",
    WebStringKey.Latency to "Latence",
    WebStringKey.ViewAll to "Voir Tout",

    // Threat / Results
    WebStringKey.BreadcrumbHome to "Accueil",
    WebStringKey.BreadcrumbScans to "Analyses",
    WebStringKey.OfflineProtection to "Protection Hors Ligne",
    WebStringKey.VerdictHighRisk to "HAUT RISQUE DÉTECTÉ",
    WebStringKey.VerdictDangerous to "Dangereux",
    WebStringKey.VerdictDangerousDesc to "Le code QR scanné contient des indicateurs malveillants associés au phishing et au vol d'identifiants. Ne continuez pas vers l'URL cible.",
    WebStringKey.ThreatConfidence to "Confiance Menace",
    WebStringKey.FlagPhishing to "Tentative de Phishing",
    WebStringKey.FlagObfuscated to "Script Obfusqué",
    WebStringKey.FlagHomograph to "Attaque Homographe",
    WebStringKey.ClearHistory to "Tout Effacer",
    WebStringKey.SectionAttackBreakdown to "Détail de l'Attaque",
    WebStringKey.AttackHomographTitle to "Attaque Homographe / IDN",
    WebStringKey.AttackHomographDesc to "Caractères cyrilliques imitant l'alphabet latin détectés.",
    WebStringKey.AttackVisualLabel to "Apparence Visuelle",
    WebStringKey.AttackPunycodeLabel to "Punycode Réel",
    WebStringKey.AttackHomographExplain to "Le domaine utilise le cyrillique 'а' (U+0430) au lieu du latin 'a' (U+0061). Cette technique est couramment utilisée pour tromper les utilisateurs en leur faisant croire qu'ils visitent un service légitime.",
    WebStringKey.AttackRedirectTitle to "Chaîne de Redirection Suspecte",
    WebStringKey.AttackRedirectDesc to "3 sauts détectés impliquant des raccourcisseurs d'URL connus.",
    WebStringKey.RedirectStart to "Scan Code QR",
    WebStringKey.RedirectHop to "Saut Intermédiaire",
    WebStringKey.RedirectFinal to "Destination Finale",
    WebStringKey.AttackJsTitle to "JavaScript Obfusqué",
    WebStringKey.AttackJsDesc to "Chaîne à haute entropie détectée dans les paramètres d'URL.",
    WebStringKey.SectionActions to "Actions Recommandées",
    WebStringKey.ActionBlock to "Bloquer & Signaler",
    WebStringKey.ActionBlockDesc to "Empêcher l'accès et notifier l'administrateur",
    WebStringKey.ActionQuarantine to "Mettre en Quarantaine",
    WebStringKey.ActionQuarantineDesc to "Ouvrir en toute sécurité pour analyse",
    WebStringKey.Expected to "Attendu : ",
    WebStringKey.Detected to "Détecté : ",
    WebStringKey.ExplainableSecurity to "Sécurité Explicable",
    WebStringKey.UrlBreakdown to "DÉCOMPOSITION DE L'URL",
    WebStringKey.FullUrl to "URL COMPLÈTE",
    WebStringKey.OpenInBrowser to "Ouvrir dans le Navigateur (Risqué)",
    WebStringKey.OpenWarning to "Ouvrir cette URL dans votre navigateur peut vous exposer à des risques de sécurité.",
    WebStringKey.RestrictedMode to "Mode Restreint",
    WebStringKey.RestrictedDesc to "Cette URL a été signalée comme potentiellement dangereuse. Examinez l'analyse ci-dessous avant de continuer.",
    WebStringKey.DangerousWarning to "Cette URL a été signalée comme potentiellement dangereuse. L'ouvrir peut vous exposer à du phishing, des malwares ou d'autres menaces de sécurité. Êtes-vous sûr de vouloir continuer ?",
    WebStringKey.CopyUrl to "Copier l'URL",
    WebStringKey.Share to "Partager",
    WebStringKey.Dismiss to "Ignorer",
    WebStringKey.ReasonDomainAge to "L'âge du domaine est inférieur à 24 heures.",
    WebStringKey.ReasonSignatures to "Correspondance avec 3 signatures dans la base de données locale de phishing.",
    WebStringKey.ReasonAsn to "L'IP cible est située dans un ASN à haut risque.",
    WebStringKey.SectionMeta to "Méta Scan",
    WebStringKey.MetaTime to "Heure du Scan",
    WebStringKey.MetaSource to "Provenance",
    WebStringKey.MetaEngine to "Moteur",
    WebStringKey.MetaOfflineGuaranteeLabel to "Garantie Hors Ligne :",
    WebStringKey.MetaOfflineGuaranteeDesc to "Cette image a été analysée localement sur votre appareil. Aucune donnée n'a été envoyée au cloud pour ce verdict.",
    
    // Results Page
    WebStringKey.ScanComplete to "Scan Terminé",
    WebStringKey.Loading to "Chargement...",
    WebStringKey.AnalyzedOffline to "Analysé hors ligne en <5ms",
    WebStringKey.NoDataLeaves to "Aucune donnée ne quitte l'appareil",
    WebStringKey.ActiveProtection to "Protection Active",
    WebStringKey.ConfidenceScore to "Score de Confiance",
    WebStringKey.Analyzing to "ANALYSE EN COURS...",
    WebStringKey.ProcessingResults to "Traitement des résultats du scan...",
    WebStringKey.RiskAssessment to "Évaluation des Risques",
    WebStringKey.AnalysisTime to "Temps d'Analyse",
    WebStringKey.Heuristics to "Heuristiques",
    WebStringKey.TopAnalysisFactors to "Principaux Facteurs d'Analyse",
    WebStringKey.Pass to "RÉUSSI",
    WebStringKey.Info to "INFO",
    WebStringKey.Clean to "PROPRE",
    WebStringKey.ValidSslCertificate to "Certificat SSL Valide",
    WebStringKey.SslCertificateDesc to "Certificat émis par DigiCert Inc. Aucune anomalie dans la chaîne de confiance.",
    WebStringKey.EstablishedDomain to "Domaine Établi",
    WebStringKey.EstablishedDomainDesc to "Domaine enregistré il y a > 5 ans. Faible probabilité de fraude.",
    WebStringKey.BlacklistStatus to "Statut Liste Noire",
    WebStringKey.BlacklistStatusDesc to "Non trouvé dans 52 bases de données de menaces locales.",
    WebStringKey.BackToDashboard to "Retour au Tableau de Bord",
    WebStringKey.ShareReport to "Partager le Rapport",
    WebStringKey.CopyLink to "Copier le Lien",
    WebStringKey.LinkCopied to "Lien copié dans le presse-papiers !",
    
    // Game Page
    WebStringKey.BeatTheBot to "Battre le Bot",
    WebStringKey.BeatTheBotDesc to "Défiez notre IA hors ligne. Pouvez-vous détecter le phishing plus vite ?",
    WebStringKey.SessionId to "ID de Session",
    WebStringKey.EndSession to "Terminer la Session",
    WebStringKey.Round to "Manche",
    WebStringKey.BrowserPreview to "Aperçu du Navigateur",
    WebStringKey.MakeDecision to "Prenez votre décision",
    WebStringKey.Phishing to "Hameçonnage",
    WebStringKey.Legitimate to "Légitime",
    WebStringKey.LiveHint to "Indice en Direct",
    WebStringKey.LiveScoreboard to "Tableau de Score en Direct",
    WebStringKey.VsMode to "MODE VS",
    WebStringKey.You to "Vous",
    WebStringKey.Points to "pt",
    WebStringKey.Streak to "Série",
    WebStringKey.Accuracy to "Précision",
    WebStringKey.MehrGuardBot to "Bot Mehr Guard",
    WebStringKey.Confidence to "Confiance",
    WebStringKey.RoundAnalysis to "Analyse de la Manche",
    WebStringKey.Analysis to "Analyse",
    WebStringKey.CorrectDecision to "Bonne Décision !",
    WebStringKey.IdentifiedSafe to "Vous avez correctement identifié l'URL sûre.",
    WebStringKey.AiNeuralAnalysis to "Analyse Neurale IA",
    WebStringKey.WhyBotFlagged to "Pourquoi le bot l'a signalé",
    WebStringKey.EducationalNote to "Note Éducative",
    WebStringKey.Correct to "Correct !",
    WebStringKey.SpottedPhishing to "Vous avez correctement détecté l'URL de phishing.",
    WebStringKey.Response to "Réponse",
    WebStringKey.NextRound to "Manche Suivante",
    WebStringKey.GameOver to "Partie Terminée !",
    WebStringKey.FinalResults to "Résultats Finaux",
    WebStringKey.YourScore to "Votre Score",
    WebStringKey.BotScore to "Score du Bot",
    WebStringKey.BestStreak to "Meilleure Série",
    WebStringKey.PlayAgain to "Rejouer",
    WebStringKey.ReturnToDashboard to "Retour au Tableau de Bord",
    
    // Export Page
    WebStringKey.ExportSecurityReport to "Exporter le Rapport de Sécurité",
    WebStringKey.GenerateReport to "Générez des rapports de sécurité complets à partir de votre historique de scans.",
    WebStringKey.ReportFormat to "Format du Rapport",
    WebStringKey.HumanReadable to "Rapport Lisible",
    WebStringKey.HumanReadableDesc to "PDF avec analyse visuelle et résumé exécutif",
    WebStringKey.MachineReadable to "Données Machine",
    WebStringKey.MachineReadableDesc to "Format JSON pour intégration SIEM",
    WebStringKey.DateRange to "Période",
    WebStringKey.Last7Days to "7 Derniers Jours",
    WebStringKey.Last30Days to "30 Derniers Jours",
    WebStringKey.Last90Days to "90 Derniers Jours",
    WebStringKey.AllTime to "Tout le Temps",
    WebStringKey.CustomRange to "Période Personnalisée",
    WebStringKey.ReportSections to "Sections du Rapport",
    WebStringKey.ExecutiveSummary to "Résumé Exécutif",
    WebStringKey.ThreatBreakdown to "Analyse des Menaces",
    WebStringKey.ScanTimeline to "Chronologie des Scans",
    WebStringKey.SafeUrlList to "Liste des URLs Sûres",
    WebStringKey.GenerateExport to "Exporter le Rapport",
    
    // Toast / Notifications
    WebStringKey.Success to "Succès !",
    WebStringKey.Error to "Erreur",
    WebStringKey.Warning to "Avertissement",
    WebStringKey.CopiedToClipboard to "Copié dans le presse-papiers",
    
    // General Actions
    WebStringKey.Cancel to "Annuler",
    WebStringKey.Confirm to "Confirmer",
    WebStringKey.Save to "Enregistrer",
    WebStringKey.Delete to "Supprimer",
    WebStringKey.Edit to "Modifier",
    WebStringKey.Close to "Fermer",
    WebStringKey.Back to "Retour",
    WebStringKey.Next to "Suivant",
    WebStringKey.Previous to "Précédent",
    WebStringKey.Submit to "Soumettre",
    WebStringKey.Reset to "Réinitialiser",
    WebStringKey.Clear to "Effacer",
    WebStringKey.Search to "Rechercher",
    WebStringKey.Filter to "Filtrer",
    WebStringKey.Sort to "Trier",
    
    // Accessibility
    WebStringKey.ToggleMenu to "Basculer le menu",
    WebStringKey.ToggleTheme to "Basculer le thème",
    WebStringKey.Notifications to "Notifications",
    WebStringKey.Help to "Aide",
    WebStringKey.Profile to "Profil",
    WebStringKey.ToggleLightDarkMode to "Basculer mode clair/sombre",
    
    // Placeholders
    WebStringKey.UrlInputPlaceholder to "Collez URL à analyser (ex: https://example.com)",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    
    // Export Page Additional
    WebStringKey.Scan to "Analyser",
    WebStringKey.Result to "Résultat",
    WebStringKey.ReportGeneration to "Génération de Rapport",
    WebStringKey.ReportGenerationDesc to "Configurez les formats et téléchargez votre analyse des menaces.",
    WebStringKey.OfflineSecurity to "Sécurité Hors Ligne",
    WebStringKey.OfflineSecurityDesc to "Vos données ne quittent jamais cet appareil. Tout le traitement est local.",
    WebStringKey.ChooseFormat to "Choisir le Format",
    WebStringKey.PdfFormatDesc to "Format PDF. Idéal pour le partage.",
    WebStringKey.JsonFormatDesc to "Format JSON. Idéal pour intégration SIEM.",
    WebStringKey.Copy to "Copier",
    WebStringKey.LivePreview to "Aperçu en Direct",
    WebStringKey.ReadOnly to "Lecture Seule",
    WebStringKey.ThreatAnalysisReport to "Rapport d'Analyse des Menaces",
    WebStringKey.Verdict to "Verdict",
    WebStringKey.RiskScore to "Score de Risque",
    WebStringKey.TargetUrl to "URL Cible",
    WebStringKey.AnalysisSummaryLabel to "Résumé de l'Analyse",
    WebStringKey.TechnicalIndicators to "Indicateurs Techniques",
    WebStringKey.ExportInfoNote to "Les exports incluent tous les vecteurs de menaces identifiés et l'analyse de charge utile.",
    
    // Trust Centre Page
    WebStringKey.AllowList to "Liste Autorisée",
    WebStringKey.BlockList to "Liste Bloquée",
    WebStringKey.AddDomain to "Ajouter un Domaine",
    WebStringKey.RemoveDomain to "Supprimer le Domaine",
    WebStringKey.TrustedDomains to "Domaines de Confiance",
    WebStringKey.BlockedDomains to "Domaines Bloqués",
    WebStringKey.DomainPlaceholder to "Entrez un domaine (ex: example.com)",
    
    // Game Page Additional
    WebStringKey.Safe to "Sûr",
    WebStringKey.TimeAgo to "il y a",
    WebStringKey.MinutesAgo to "min avant",
    WebStringKey.HoursAgo to "h avant",
    
    // Misc
    WebStringKey.Critical to "CRITIQUE",
    WebStringKey.Warn to "AVERTISSEMENT",
    
    // Trust Centre - Sensitivity
    WebStringKey.PhishingDetectionSensitivity to "Sensibilité de Détection du Phishing",
    WebStringKey.SensitivityDescription to "Ajustez les seuils heuristiques. Une sensibilité plus élevée peut augmenter les faux positifs.",
    WebStringKey.SensitivityLow to "Faible",
    WebStringKey.SensitivityBalanced to "Équilibré",
    WebStringKey.SensitivityParanoia to "Paranoïa",
    WebStringKey.BalancedModeRecommended to "Mode Équilibré (Recommandé)",
    WebStringKey.BalancedModeDesc to "Recherche les modèles malveillants connus et les incohérences heuristiques. Bloque les attaques homoglyphes et les chaînes de redirection.",
    WebStringKey.LowSensitivityMode to "Mode Sensibilité Faible",
    WebStringKey.LowSensitivityModeDesc to "Bloque uniquement les URLs malveillantes connues de la base de données des menaces. Minimum de faux positifs, mais peut manquer les nouvelles attaques.",
    WebStringKey.ParanoiaMode to "Mode Paranoïa",
    WebStringKey.ParanoiaModeDesc to "Protection maximale. Bloque tout motif suspect incluant les domaines nouvellement enregistrés, les TLDs peu communs et toute URL avec des astuces d'encodage potentielles.",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guard utilise des moteurs d'analyse heuristique locaux. Aucune donnée d'image, chaîne URL ou métadonnées ne quitte cet appareil pendant l'analyse. Votre vie privée est mathématiquement garantie.",
    WebStringKey.SignalBrandImpersonation to "Usurpation potentielle de marque détectée",
    WebStringKey.SignalCredentialParams to "Paramètres liés aux identifiants dans l'URL",
    WebStringKey.SignalEncodedPayload to "Données encodées détectées dans les paramètres de requête",
    WebStringKey.SignalExcessiveSubdomains to "Profondeur excessive de sous-domaines ({count} niveaux)",
    WebStringKey.SignalHighEntropyHost to "Haute aléatoirement dans le nom de domaine",
    WebStringKey.SignalHomographAttack to "Le domaine contient des caractères homographes/confondables",
    WebStringKey.SignalHttpNotHttps to "Utilise le protocole HTTP non sécurisé",
    WebStringKey.SignalIpAddressHost to "L'hôte est une adresse IP au lieu d'un domaine",
    WebStringKey.SignalLongUrl to "URL inhabituellement longue ({length} caractères)",
    WebStringKey.SignalLongUrlMarketing to "URL inhabituellement longue ({length} caractères) - contient des paramètres marketing",
    WebStringKey.SignalNewlyRegisteredDomain to "Domaine nouvellement enregistré détecté",
    WebStringKey.SignalNonStandardPort to "Port non standard: {port}",
    WebStringKey.SignalNumericSubdomain to "Sous-domaine uniquement numérique détecté",
    WebStringKey.SignalSuspiciousPathKeywords to "Mots-clés suspects dans le chemin ({count} trouvés)",
    WebStringKey.SignalSuspiciousTld to "TLD suspect: {tld}",
    WebStringKey.SignalUrlShortener to "Utilise un service de raccourcissement d'URL",
    WebStringKey.SecureEnvironment to "Environnement Sécurisé",
    WebStringKey.LearnLocalArchitecture to "Découvrez notre architecture locale",
    WebStringKey.NoCustomDomainsBlocked to "Aucun domaine personnalisé bloqué.",
    WebStringKey.AddManually to "Ajouter manuellement",
    WebStringKey.AddedDaysAgo to "Ajouté il y a 2 jours",
    WebStringKey.AddedWeekAgo to "Ajouté il y a 1 semaine",
    
    // Trust Centre - Privacy Controls
    WebStringKey.PrivacyControls to "Contrôles de Confidentialité",
    WebStringKey.StrictOfflineMode to "Mode Hors Ligne Strict",
    WebStringKey.DisableExternalPreviews to "Désactiver tous les aperçus de liens externes.",
    WebStringKey.AnonymousTelemetry to "Télémétrie Anonyme",
    WebStringKey.ShareDetectionStats to "Partager les stats de détection pour améliorer le ML.",
    WebStringKey.AutoCopySafeLinks to "Copie Auto des Liens Sûrs",
    WebStringKey.CopyTrustedUrls to "Copier les URLs de confiance dans le presse-papiers.",
    
    // Trust Centre - About
    WebStringKey.AboutMehrGuard to "À Propos de Mehr Guard",
    WebStringKey.OpenSourceLicenses to "Licences Open Source",
    WebStringKey.PrivacyPolicy to "Politique de Confidentialité",
    WebStringKey.Acknowledgements to "Remerciements",
    WebStringKey.ResetAllSettings to "Réinitialiser tous les paramètres",
    WebStringKey.AddToAllowlist to "Ajouter à la Liste Autorisée",
    WebStringKey.AddToBlocklist to "Ajouter à la Liste Bloquée",
    
    // Onboarding
    WebStringKey.AnalysedOfflineTitle to "Analysé hors ligne.",
    WebStringKey.YourDataStaysOnDevice to "Vos données restent sur l'appareil.",
    WebStringKey.OnboardingHeroDesc to "Mehr Guard traite chaque scan avec une analyse sécurisée sur l'appareil. Nous priorisons la sécurité explicable sans télémétrie cloud.",
    WebStringKey.OnDeviceAnalysis to "Analyse sur l'Appareil",
    WebStringKey.OnDeviceAnalysisDesc to "Toute la détection de menaces s'exécute localement sur votre appareil. Aucune donnée ne quitte votre système.",
    WebStringKey.NoCloudLogs to "Aucun Journal Cloud",
    WebStringKey.NoCloudLogsDesc to "Nous désactivons strictement la télémétrie sortante pour les scans. Les résultats et hashes restent locaux.",
    WebStringKey.OnDeviceDB to "Base de Données sur l'Appareil",
    WebStringKey.OnDeviceDBDesc to "La base de données complète des signatures de menaces est téléchargée sur votre appareil pour des recherches en millisecondes.",
    WebStringKey.DataLifecycleVerification to "Vérification du Cycle de Vie des Données",
    WebStringKey.SecurityAuditPass to "Audit de Sécurité : RÉUSSI",
    
    // Footer
    WebStringKey.Copyright to "© 2024 Mehr Guard Security Inc. Tous droits réservés.",
    WebStringKey.Support to "Assistance",
    WebStringKey.Terms to "Conditions",
    WebStringKey.SystemsOperational to "Systèmes Opérationnels",
    WebStringKey.SystemSecure to "Système Sécurisé",
    
    // Version / Build Info
    WebStringKey.VersionStatus to "v2.4.1 • Système Sécurisé",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2024.12.19",
    WebStringKey.VerifiedBy to "Vérifié par Mehr Guard Enterprise",
    
    // User Profile (Sample)
    WebStringKey.SampleUserName to "Jean Dupont",
    WebStringKey.SampleUserRole to "Analyste Sécurité",
    
    // Export Preview
    WebStringKey.DetailLabel to "Libellé du Détail",
    WebStringKey.DetailValue to "Valeur du Détail",
    WebStringKey.Suspicious to "Suspect",
    
    // Game Modal Strings
    WebStringKey.IncorrectDecision to "Décision Incorrecte",
    WebStringKey.WrongAnswer to "Oups ! Ce n'était pas correct.",
    WebStringKey.ResponseTime to "Temps de Réponse",
    WebStringKey.IncomingMessage to "Message Entrant",
    WebStringKey.CertificateIssuer to "L'émetteur du certificat correspond au propriétaire du domaine",
    WebStringKey.DomainAgeTrust to "Âge du domaine > 5 ans (Haute confiance)",
    WebStringKey.WhitelistedRank to "Top 1k Alexa en liste blanche locale",
    
    // Game Tips/Hints
    WebStringKey.GameEducationalNote to "Note Éducative",
    WebStringKey.GameHintTitle to "Indice du Jeu",
    
    // Trust Modal
    WebStringKey.AddToAllowlistTitle to "Ajouter à la Liste Autorisée",
    WebStringKey.AddToBlocklistTitle to "Ajouter à la Liste Bloquée",
    WebStringKey.EnterDomainPrompt to "Entrez un domaine à ajouter à votre liste",
    
    // Additional Game Strings
    WebStringKey.LatencyMs to "Latence",
    WebStringKey.StreakFire to "Série",
    WebStringKey.AccuracyPercent to "Précision",
    WebStringKey.ConfidencePercent to "Confiance",
    
    // Languages
    WebStringKey.English to "Anglais",
    WebStringKey.German to "Allemand",
    WebStringKey.Spanish to "Espagnol",
    WebStringKey.French to "Français",
    WebStringKey.ChineseSimplified to "Chinois (Simplifié)",
    WebStringKey.Japanese to "Japonais",
    WebStringKey.Hindi to "Hindou",
    WebStringKey.Arabic to "Arabe",
    WebStringKey.Indonesian to "Indonésien",
    WebStringKey.Italian to "Italien",
    WebStringKey.Korean to "Coréen",
    WebStringKey.Portuguese to "Portugais",
    WebStringKey.Russian to "Russe",
    WebStringKey.Thai to "Thaï",
    WebStringKey.Turkish to "Turc",
    WebStringKey.Vietnamese to "Vietnamien"
,
    WebStringKey.ComponentVoting to "Vote des Composants",
    WebStringKey.Heuristic to "Heuristique",
    WebStringKey.MLModel to "Modèle ML",
    WebStringKey.Brand to "Marque",
    WebStringKey.TLD to "TLD",
    WebStringKey.VotingExplanation to "Le vote majoritaire détermine le verdict: 3+ SÛR = vert, 2+ MALVEILLANT = rouge"
,
    // Results Page Placeholders,
    WebStringKey.WaitingForScan to "En attente de scan...",
    WebStringKey.WaitingForAnalysis to "En attente d'analyse...",
    WebStringKey.ScanURLToSeeResults to "Scannez une URL pour voir les résultats détaillés.",

    // Keyboard Shortcuts & Settings
    WebStringKey.KeyboardShortcuts to "Raccourcis Clavier",
    WebStringKey.StartScanner to "Démarrer le Scanner",
    WebStringKey.CloseMenuModal to "Fermer le Menu / Modal",
    WebStringKey.NavigateToDashboard to "Aller au Tableau de Bord",
    WebStringKey.NavigateToHistory to "Historique des Scans",
    WebStringKey.NavigateToTrust to "Centre de Confiance / Liste Autorisée",
    WebStringKey.NavigateToGame to "Jeu Battre le Bot",
    WebStringKey.ShowHelp to "Afficher l'Aide",
    WebStringKey.GotIt to "Compris",
    WebStringKey.SecuritySettings to "Paramètres de Sécurité",
    WebStringKey.SensitivityLevel to "Niveau de Sensibilité",
    WebStringKey.AutoBlockThreats to "Bloquer les Menaces Automatiquement",
    WebStringKey.RealTimeScanning to "Scan en Temps Réel",
    WebStringKey.SoundAlerts to "Alertes Sonores",
    WebStringKey.ThreatAlerts to "Alertes de Menaces",
    WebStringKey.ShowConfidenceScore to "Afficher le Score de Confiance",
    WebStringKey.CompactView to "Vue Compacte",
    WebStringKey.ResetDefaults to "Réinitialiser les Valeurs par Défaut",
    WebStringKey.SaveAndContinue to "Enregistrer et Continuer",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "À propos de Mehr Guard Security",
    WebStringKey.ActualDomain to "Domaine réel",
    WebStringKey.AnalysisComplete to "Analyse terminée",
    WebStringKey.AutoBlockThreatsDesc to "Bloquer automatiquement les menaces",
    WebStringKey.AwaitingScanLabel to "En attente de scan",
    WebStringKey.BrandImpersonation to "Usurpation de marque",
    WebStringKey.CautionAdvised to "Prudence conseillée",
    WebStringKey.CompactViewDesc to "Vue compacte",
    WebStringKey.DoNotVisit to "NE PAS VISITER",
    WebStringKey.DoNotVisitDesc to "Hameçonnage à haute confiance détecté. Cette URL présente plusieurs indicateurs malveillants.",
    WebStringKey.DomainUsesInternationalChars to "Ce domaine utilise des caractères internationaux qui peuvent imiter des domaines légitimes.",
    WebStringKey.GoToScanner to "Aller au scanner",
    WebStringKey.Hebrew to "Hébreu",
    WebStringKey.HelpKeyboardShortcuts to "Raccourcis clavier",
    WebStringKey.HeuristicAnalysis to "Analyse heuristique",
    WebStringKey.HeuristicAnalysisDesc to "URL signalée en fonction de plusieurs facteurs de risque détectés par le moteur d'analyse.",
    WebStringKey.HiddenDestination to "Destination cachée",
    WebStringKey.HighRisk to "Risque élevé",
    WebStringKey.HighRiskLabel to "RISQUE ÉLEVÉ",
    WebStringKey.HomographIdnAttack to "Attaque homographe / IDN",
    WebStringKey.InternationalizedDomainDetected to "Nom de domaine internationalisé détecté.",
    WebStringKey.JustNow to "À l'instant",
    WebStringKey.KeyboardShortcutsDesc to "Raccourcis clavier pour un accès rapide",
    WebStringKey.LiveFeedActive to "FLUX EN DIRECT ACTIF",
    WebStringKey.LowRisk to "Risque faible",
    WebStringKey.LowRiskLabel to "RISQUE FAIBLE",
    WebStringKey.Malicious to "Malveillant",
    WebStringKey.MediumRiskLabel to "RISQUE MOYEN",
    WebStringKey.NoData to "PAS DE DONNÉES",
    WebStringKey.NoScanDataResults to "Aucune donnée de scan disponible. Veuillez scanner une URL pour voir les résultats d'analyse.",
    WebStringKey.NoUrlScanned to "Aucune URL scannée",
    WebStringKey.Persian to "Persan",
    WebStringKey.PhishingIndicators to "Indicateurs d'hameçonnage",
    WebStringKey.ProceedWithCaution to "PROCÉDER AVEC PRUDENCE",
    WebStringKey.ProceedWithCautionDesc to "Certains indicateurs suspects détectés. Vérifiez la source avant de saisir des informations sensibles.",
    WebStringKey.RealTimeScanningDesc to "Scan en temps réel",
    WebStringKey.RedirectShortenerDetected to "Redirection/raccourcisseur détecté",
    WebStringKey.SafeToVisit to "SÛR À VISITER",
    WebStringKey.SafeToVisitDesc to "Vérifié par heuristiques locales v2.4. Aucun motif d'hameçonnage, script obscurci ou correspondance de liste noire trouvé.",
    WebStringKey.SafetyScore to "Score de sécurité",
    WebStringKey.ScanCompleteLabel to "Scan terminé",
    WebStringKey.ScanToAnalyze to "Scannez un code QR ou entrez une URL à analyser.",
    WebStringKey.ScannedURLLabel to "URL scannée",
    WebStringKey.SecuritySignal to "Signal de sécurité",
    WebStringKey.SensitivityLevelDesc to "Niveau de sensibilité",
    WebStringKey.SensitivityPermissive to "Permissif",
    WebStringKey.SensitivityStrict to "Strict",
    WebStringKey.SettingsDetection to "Détection",
    WebStringKey.SettingsDisplay to "Affichage",
    WebStringKey.SettingsLanguage to "Langue",
    WebStringKey.SettingsLanguageDesc to "Sélectionner la langue de l'interface",
    WebStringKey.SettingsNotifications to "Notifications",
    WebStringKey.SettingsSavedAutomatically to "Les paramètres sont enregistrés automatiquement et synchronisés entre les sessions.",
    WebStringKey.ShowConfidenceScoreDesc to "Afficher le score de confiance",
    WebStringKey.SoundAlertsDesc to "Alertes sonores",
    WebStringKey.SuspiciousDomain to "Domaine suspect",
    WebStringKey.SuspiciousEncoding to "Encodage suspect",
    WebStringKey.SuspiciousKeywords to "Mots-clés suspects",
    WebStringKey.SuspiciousTld to "TLD suspect",
    WebStringKey.SuspiciousTldDesc to "Le domaine utilise {tld} TLD généralement associé aux sites malveillants.",
    WebStringKey.SuspiciousUrlParams to "Paramètres URL suspects",
    WebStringKey.SuspiciousUrlParamsDesc to "L'URL contient des paramètres complexes ou potentiellement obscurcis.",
    WebStringKey.ThreatAlertsDesc to "Alertes de menaces",
    WebStringKey.ThreatDetected to "Menace détectée",
    WebStringKey.UnableToDetermine to "Impossible de déterminer le verdict. Veuillez réessayer.",
    WebStringKey.Unknown to "Inconnu",
    WebStringKey.UnknownURL to "URL inconnue",
    WebStringKey.UrlShortenerDesc to "L'URL utilise un service de raccourcissement qui masque la destination finale.",
    WebStringKey.UrlShortenerDetected to "Raccourcisseur d'URL détecté",
    WebStringKey.VersionOfflineReady to "Prêt hors ligne",
    WebStringKey.VisualAppearance to "Apparence visuelle",
    WebStringKey.WaitingForAnalysisLabel to "En attente d'analyse..."
)

internal val FrenchCommonStrings = mapOf(
    "\"Always expand short links before scanning. The bot does this automatically by following redirect headers without rendering the page.\"" to "\"Toujours développer les liens courts avant de numériser. Le robot le fait automatiquement en suivant les en-têtes de redirection sans afficher la page. \"",
    "\"AusPost: Your parcel failed delivery due to incorrect address details. Please update immediately via the link above to avoid return.\"" to "\"AusPost : votre colis a échoué en raison d'une adresse incorrecte. Veuillez mettre à jour immédiatement via le lien ci-dessus pour éviter tout retour.\"",
    "\"Commonwealth Bank: Your account has been locked due to suspicious activity. Verify your identity immediately.\"" to "\"Banque du Commonwealth : votre compte a été verrouillé en raison d'une activité suspecte. Vérifiez immédiatement votre identité. (R3)\"",
    "\"Let's Encrypt (R3)\"" to "\"Phishing\"",
    "\"Phishing\"" to "\"Vous avez gagné une carte cadeau de 500 \$ ! Cliquez pour réclamer votre prix.\"",
    "\"You won a \$500 gift card! Click to claim your prize.\"" to "\"Votre identifiant Apple a été utilisé pour vous connecter sur un nouvel appareil, vérifiez immédiatement.\"",
    "\"Your Apple ID was used to sign in on a new device. If this was not you, verify immediately.\"" to "\"Votre compte PayPal a été limité.»",
    "\"Your PayPal account has been limited. Please update your information.\"" to "+10-15 points. Signal dépendant du contexte",
    "+10-15 points — Context-dependent signal" to "+10-15 points — Suggestif mais non concluant",
    "+10-15 points — Suggestive but not conclusive" to "+10-15 points — Suspect mais non définitif",
    "+10-15 points — Suspicious but not definitive" to "+10-20 points — Contribue au score de risque global",
    "+10-20 points — Contributes to overall risk score" to "+15-20 points — Nécessite de la prudence, non définitif",
    "+15-20 points — Requires caution, not definitive" to "+15-20 points — Nécessite une inspection à destination",
    "+15-20 points — Requires destination inspection" to "+15-20 points — Base de sécurité non respectée",
    "+15-20 points — Security baseline not met" to "+20-30 points — Technique de tromperie délibérée",
    "+20-30 points — Deliberate deception technique" to "+20-30 points — Les marques légitimes les utilisent rarement",
    "+20-30 points — Legitimate brands rarely use these" to "+25-30 points — Fort indicateur de phishing",
    "+25-30 points — Strong phishing indicator" to "+30-35 points — Nécessite une enquête sur la réalité réelle caractères",
    "+30-35 points — Requires investigation of actual characters" to "+30-40 points — Il s'agit d'un indicateur principal de phishing",
    "+30-40 points — This is a primary phishing indicator" to "+40-50 points — Attaque avancée nécessitant une tromperie intentionnelle",
    "+40-50 points — Advanced attack requiring intentional deception" to "+5-10 points — Signal mineur",
    "+5-10 points — Minor signal" to "- Heuristique : [[PH0]]",
    "- Heuristics: {list}" to "- Redirections : {list}",
    "- Redirects: {count}" to "- Émetteur SSL : {count}",
    "- SSL Issuer: {issuer}" to "- Type de menace : {issuer}",
    "- Threat Type: {type}" to "il y a 1 heure • Phishing",
    "1 hr ago • Phishing" to "100 % hors ligne",
    "100% offline" to "il y a 2 heures",
    "2 hours ago" to "il y a 2 minutes • Sûr",
    "2 mins ago • Safe" to "25+ AI Heuristics",
    "25+ AI Heuristics" to "3 sauts détectés impliquant des raccourcisseurs d'URL connus.",
    "3 hops detected involving known URL shorteners." to "il y a 3 heures • Sûr",
    "3 hrs ago • Safe" to "350 pts",
    "350 pts" to "400 pts",
    "400 pts" to "il y a 5 heures • Sûr",
    "5 hrs ago • Safe" to "< 24 heures",
    "< 24 hours" to "Une tentative de phishing a été bloquée avec succès",
    "A phishing attempt was successfully blocked" to "Une URL plus courte et plus propre réduirait cette contribution de signal d'environ 8 points.",
    "A shorter, cleaner URL would reduce this signal contribution by ~8 points." to "AD",
    "AD" to "Détection de phishing basée sur l'IA s'exécutant à 100 % hors ligne dans votre navigateur.",
    "AI-powered phishing detection running 100% offline in your browser." to "Détection de phishing basée sur l'IA qui s'exécute",
    "AI-powered phishing detection that runs" to "AM",
    "AM" to "À propos [[MARQUE]]",
    "About Mehr Guard" to "Précision",
    "Accuracy" to "Précision :",
    "Accuracy:" to "Remerciements",
    "Acknowledgements" to "Active",
    "Active" to "Protection active",
    "Active Protection" to "Scanner actif",
    "Active Scanner" to "Punycode réel (où il va)",
    "Actual Punycode (Where it goes)" to "Ajouter Domaine",
    "Add Domain" to "Ajouter manuellement",
    "Add manually" to "Ajouter à la liste autorisée",
    "Add to Allowlist" to "Ajouter à la liste bloquée",
    "Add to Blocklist" to "Ajouté il y a 1 semaine",
    "Added 1 week ago" to "Ajouté il y a 2 jours",
    "Added 2 days ago" to "Ajouté [[PH0]] à [[PH1]]",
    "Added {domain} to {list}" to "Ajuster les seuils heuristiques. Une sensibilité plus élevée peut augmenter les faux positifs.",
    "Adjust heuristic thresholds. Higher sensitivity may increase false positives." to "Alex Chen",
    "Alex Chen" to "Alex Morgan",
    "Alex Morgan" to "Alexa Top 1000 site",
    "Alexa Top 1000 site" to "Toutes les URL s'afficheront comme MALVEILLANTES à des fins de démonstration",
    "All URLs will show as MALICIOUS for demo purposes" to "Toute l'exécution de code se produit dans un conteneur éphémère qui est détruit après chaque analyse. Cela garantit que les charges utiles malveillantes ne pourront jamais s'échapper vers votre système.",
    "All code execution happens in an ephemeral container that is destroyed after each scan. This ensures malicious payloads can never escape to your system." to "Toutes les notifications marquées comme lues",
    "All notifications marked as read" to "Liste d'autorisation",
    "Allow List" to "Liste d'autorisation",
    "Allowlist" to "Analysée hors ligne.",
    "Analysed offline." to "Analyse",
    "Analysis" to "Analyse terminée",
    "Analysis Complete" to "Chargement du moteur d'analyse...",
    "Analysis Engine Loading..." to "Analyse Résumé",
    "Analysis Summary" to "Temps d'analyse",
    "Analysis Time" to "Analyser",
    "Analyze" to "Analyser cette URL",
    "Analyze This URL" to "Analyser l'URL",
    "Analyze URL" to "Analysé hors ligne en <5 ms",
    "Analyzed offline in <5ms" to "Analyse hors ligne...",
    "Analyzing offline..." to "Télémétrie anonyme",
    "Anonymous Telemetry" to "Télémétrie anonyme",
    "Anonymous Telemetry disabled" to "Télémétrie anonyme désactivé",
    "Anonymous Telemetry enabled" to "Télémétrie anonyme activée",
    "Apple Support" to "Assistance Apple",
    "Apple only uses apple.com for all account-related activities. Be wary of domains containing brand names but with different extensions." to "Apple utilise uniquement apple.com pour toutes les activités liées au compte. Méfiez-vous des domaines contenant des noms de marque mais avec des extensions différentes.",
    "Apple would never use a third-party domain for account verification. Check the actual domain name." to "Apple n'utilisera jamais un domaine tiers pour la vérification du compte. Vérifiez le nom de domaine actuel.",
    "Are you sure you want to end this session? Progress will be lost." to "Êtes-vous sûr de vouloir mettre fin à cette session ? Les progrès seront perdus.",
    "Atlassian" to "Atlassian",
    "Atlassian is a legitimate software company. Their primary domain atlassian.com is trustworthy." to "Atlassian est une société de logiciels légitime. Leur domaine principal atlassian.com est digne de confiance.",
    "Attack Breakdown" to "Répartition des attaques",
    "Attackers create domains that look like trusted brands to steal credentials" to "Les attaquants créent des domaines qui ressemblent à des marques de confiance pour voler des informations d'identification",
    "Auto-Block Threats" to "Menaces de blocage automatique",
    "Auto-Copy Safe Links" to "Copie automatique des liens sécurisés",
    "Auto-Copy Safe Links disabled" to "Copie automatique des liens sécurisés désactivée",
    "Auto-Copy Safe Links enabled" to "Copie automatique des liens sécurisés activé",
    "Automatically block high-risk URLs" to "Bloquer automatiquement les URL à haut risque",
    "Back online" to "Retour en ligne",
    "Back to Dashboard" to "Retour au tableau de bord",
    "Balanced" to "Équilibré",
    "Balanced Mode (Recommended)" to "Mode équilibré (recommandé)",
    "Beat the Bot" to "Battre le Bot",
    "Beat the Bot →" to "Battre le Bot →",
    "Best Streak" to "Meilleure séquence",
    "Blacklist Match" to "Match sur la liste noire",
    "Blacklist Status" to "Statut de la liste noire",
    "Block & Report" to "Bloquer et signaler",
    "Blocklist" to "Liste de blocage",
    "Bot Score" to "Score du bot",
    "Brand Impersonation" to "Usurpation d'identité de marque",
    "Brand Impersonation Detected" to "Marque Usurpation d'identité détectée",
    "Brands Detected" to "Marques détectées",
    "Browser Preview" to "Aperçu du navigateur",
    "Built for" to "Construit pour",
    "CLEAN" to "CLEAN",
    "CRITICAL" to "CRITIQUE",
    "Camera API (QR scanning unavailable)" to "API de la caméra (analyse QR indisponible)",
    "Camera Access Required" to "Accès à la caméra requis",
    "Camera Not Available" to "Caméra non disponible Disponible",
    "Camera activated" to "Caméra activée",
    "Camera error: {error}" to "Erreur de caméra : {error}",
    "Camera not supported in this browser" to "Caméra non prise en charge dans ce navigateur",
    "Camera permission denied" to "Autorisation de la caméra refusée",
    "Can redirect through tracking or to malicious destinations" to "Peut rediriger via le suivi ou vers des destinations malveillantes",
    "Cancel" to "Annuler",
    "Caution" to "Attention",
    "Caution Advised" to "Attention Conseillé",
    "Certificate Issuer matches domain owner (DigiCert Inc)" to "L'émetteur du certificat correspond au propriétaire du domaine (DigiCert Inc)",
    "Certificate Issuer matches domain owner (DigiCert Inc)." to "L'émetteur du certificat correspond au propriétaire du domaine (DigiCert Inc).",
    "Certificate issued by DigiCert Inc. No anomalies in chain of trust." to "Certificat émis par DigiCert Inc. Aucune anomalie dans la chaîne de confiance.",
    "Certificate issued by trusted CA. No anomalies in chain of trust." to "Certificat délivré par une autorité de certification de confiance. Aucune anomalie dans la chaîne de confiance.",
    "Certificate recently issued or self-signed. Proceed with caution." to "Certificat récemment délivré ou auto-signé. Procédez avec prudence.",
    "Challenge our offline AI engine. Can you spot the phish faster?" to "Défiez notre moteur d'IA hors ligne. Pouvez-vous repérer le phishing plus rapidement ?",
    "Characters like Cyrillic \"а\" look identical to Latin \"a\" but are different" to "Les caractères comme le \"а\" cyrillique sont identiques au \"a\" latin mais sont différents",
    "Check for Updates" to "Vérifier les mises à jour",
    "Check the domain carefully. This appears to be a well-known, trusted domain." to "Vérifiez soigneusement le domaine. Il semble qu'il s'agisse d'un domaine de confiance bien connu.",
    "Choose Format" to "Choisir le format",
    "Clear All" to "Tout effacer",
    "Clear History" to "Effacer l'historique",
    "Clear scan history?" to "Effacer l'historique d'analyse ?",
    "Click a sample below or paste any URL:" to "Cliquez sur un exemple ci-dessous ou collez n'importe quelle URL :",
    "Close" to "Fermer",
    "Code execution happens in an ephemeral container. Malicious payloads never touch your OS kernel." to "L'exécution du code se produit dans un conteneur éphémère. Les charges utiles malveillantes ne touchent jamais le noyau de votre système d'exploitation.",
    "Combined with other signals, suggests intent to steal credentials" to "Combiné à d'autres signaux, suggère une intention de voler des informations d'identification",
    "Compact View" to "Vue compacte",
    "Compact view" to "Vue compacte",
    "Complete analysis is performed locally. Your camera feed and scanned data never touch an external server, ensuring absolute privacy." to "L'analyse complète est effectuée localement. Le flux de votre caméra et les données numérisées ne touchent jamais un serveur externe, garantissant ainsi une confidentialité absolue.",
    "Confidence Score" to "Score de confiance",
    "Confidence score" to "Score de confiance",
    "Confidence: 99.8%" to "Confiance : 99,8 %",
    "Configure formats and download your threat analysis." to "Configurez les formats et téléchargez votre analyse des menaces.",
    "Congratulations! You beat the bot!" to "Félicitations ! Vous avez battu le bot !",
    "Continue Anyway" to "Continuer quand même",
    "Copy" to "Copier",
    "Copy Link" to "Copier le lien",
    "Copy trusted URLs to clipboard." to "Copier les URL fiables dans le presse-papiers.",
    "Core v2.4.1 • Build 2024.12.19" to "Core v2.4.1 • Build 2024.12.19",
    "Correct Decision!" to "Corriger Décision !",
    "Correct!" to "Correct !",
    "Could not save theme preference:" to "Impossible d'enregistrer la préférence de thème :",
    "Couldn\\'t Read QR Code" to "Impossible de lire le code QR",
    "Credential Harvesting Path" to "Chemin de collecte des informations d'identification",
    "Credential Harvesting Path (/login)" to "Chemin de collecte des informations d'identification (/login)",
    "Current" to "Actuel",
    "Cyrillic characters mimicking Latin alphabet detected." to "Caractères cyrilliques imitant l'alphabet latin détecté.",
    "DB CHECK" to "DB CHECK",
    "DISCONNECTED" to "DÉCONNECTÉ",
    "DO NOT VISIT" to "NE PAS VISITEZ",
    "DOMAIN" to "DOMAINE",
    "Dangerous" to "Dangereux",
    "Dark" to "Sombre",
    "Dashboard" to "Tableau de bord",
    "Data Lifecycle Verification" to "Vérification du cycle de vie des données",
    "Data Point" to "Données Point",
    "Data exported successfully!" to "Données exportées avec succès !",
    "Data sent without encryption can be intercepted" to "Les données envoyées sans cryptage peuvent être interceptées",
    "Database Updated" to "Base de données mise à jour",
    "Decoded URL/Payload" to "URL/charge utile décodées",
    "Deep subdomains can hide the actual domain at the end" to "Les sous-domaines profonds peuvent masquer le domaine réel à la fin",
    "Destination URL obfuscated. Unable to verify final target." to "URL de destination obscurcie. Impossible de vérifier la cible finale.",
    "Details" to "Détails",
    "Detection" to "Détection",
    "Deutsch" to "Deutsch",
    "Disable all external link previews." to "Désactiver tous les aperçus de liens externes.",
    "Display" to "Affichage",
    "Display threat probability percentage" to "Afficher le pourcentage de probabilité de menace",
    "Do Not Visit This URL" to "Ne pas visiter cette URL",
    "Domain \"apple-id-verify.com\" is not owned by Apple" to "Domain \"apple-id-verify.com\" n'appartient pas à Apple",
    "Domain age > 5 years (High trust)." to "Âge du domaine > 5 ans (confiance élevée).",
    "Domain age is less than 24 hours." to "L'âge du domaine est inférieur à 24 heures.",
    "Domain already in list" to "Domaine déjà dans la liste",
    "Domain contains \"xn--\" IDN encoding" to "Le domaine contient un encodage IDN \"xn--\"",
    "Domain contains or mimics a known brand name (PayPal, Amazon, etc.)" to "Le domaine contient ou imite un nom de marque connu (PayPal, Amazon, etc.)",
    "Domain mimics known brand (PayPal → Paypa1). High-confidence phishing." to "Le domaine imite une marque connue (PayPal → Paypa1). Phishing à haute confiance.",
    "Domain mimics legitimate bank (commbank.com.au)" to "Le domaine imite une banque légitime (commbank.com.au)",
    "Domain or path contains random-looking character sequences" to "Le domaine ou le chemin contient des séquences de caractères aléatoires",
    "Domain registered > 5 years ago. Low probability of churn-and-burn." to "Domaine enregistré il y a plus de 5 ans. Faible probabilité de désabonnement.",
    "Domain registered in the last 24 hours" to "Domaine enregistré au cours des dernières 24 heures",
    "Domain uses common misspellings or character substitutions (paypa1, amaz0n)" to "Le domaine utilise des fautes d'orthographe courantes ou des substitutions de caractères (paypa1, amaz0n)",
    "Domain uses suspicious hyphenated structure (verify-deliveries.net)" to "Le domaine utilise une structure avec trait d'union suspecte (verify-deliveries.net)",
    "Don't just get a \"Block\". We provide detailed heuristic breakdowns of URL parameters, redirects, and javascript payloads." to "Ne vous contentez pas d'obtenir un \"blocage\". Nous fournissons des analyses heuristiques détaillées des paramètres d'URL, des redirections et des charges utiles javascript.",
    "Download Apps" to "Télécharger des applications",
    "Drag & Drop QR code image here" to "Faites glisser et déposez l'image du code QR ici",
    "Drag & drop a QR code image here or enable camera access to start scanning." to "Faites glisser et déposez une image de code QR ici ou activez l'accès à la caméra pour lancer la numérisation.",
    "Educational Note" to "Note pédagogique",
    "Embedded Redirect" to "Intégré Redirection",
    "Enable Camera" to "Activer la caméra",
    "Enable camera first" to "Activer d'abord la caméra",
    "End Session" to "Fin de session",
    "Engine" to "Moteur",
    "Engine Active" to "Moteur actif",
    "Engine Active (Offline)" to "Moteur actif (hors ligne)",
    "Engine initializing, please wait..." to "Initialisation du moteur, veuillez patienter...",
    "Engine initializing..." to "Initialisation du moteur...",
    "Engine not ready, using demo mode" to "Le moteur n'est pas prêt, en utilisant la démo mode",
    "English" to "Anglais",
    "Enter" to "Entrer",
    "Enter URL" to "Entrer l'URL",
    "Enter URL Manually" to "Entrer l'URL manuellement",
    "Enterprise Plan" to "Plan Entreprise",
    "Enterprise Protection Active" to "Enterprise Protection Actif",
    "Esc" to "Esc",
    "Escape" to "Escape",
    "Español" to "Español",
    "Established Domain" to "Domaine établi",
    "Excessive Subdomains" to "Sous-domaines excessifs",
    "Excessively Long URL" to "URL excessivement longue",
    "Exit" to "Quitter",
    "Explainable Defence." to "Défense explicable.",
    "Explainable Security" to "Explicable Sécurité",
    "Export" to "Exporter",
    "Export Report" to "Exporter le rapport",
    "Export Reports" to "Exporter les rapports",
    "Exports include all identified threat vectors, headers, and the raw payload analysis." to "Les exportations incluent tous les vecteurs de menaces identifiés, les en-têtes et l'analyse brute de la charge utile.",
    "External Transmission" to "Transmission externe",
    "FAIL" to "FAIL",
    "Failed to copy link" to "Échec de la copie du lien",
    "Failed to copy report" to "Échec de la copie du lien rapport",
    "Failed to get scan statistics:" to "Échec de l'obtention des statistiques d'analyse :",
    "Failed to load image" to "Échec du chargement de l'image",
    "Failed to read file" to "Échec de la lecture du fichier",
    "Failed to share" to "Échec du partage",
    "Failed to share report" to "Échec du partage du rapport",
    "File upload (image scanning unavailable)" to "Téléchargement du fichier (analyse de l'image indisponible)",
    "Final Destination" to "Destination finale",
    "Final Results" to "Final Résultats",
    "Fix it" to "Réparez-le",
    "For the best experience, use Chrome, Firefox, Safari, or Edge." to "Pour une expérience optimale, utilisez Chrome, Firefox, Safari ou Edge.",
    "Found in 3 local offline threat databases." to "Trouvé dans 3 bases de données locales de menaces hors ligne.",
    "Français" to "Français",
    "Free/cheap TLDs are heavily abused for throwaway phishing domains" to "Les TLD gratuits/bon marché sont fortement utilisés pour les domaines de phishing jetables",
    "Gallery" to "Galerie",
    "Game Over!" to "Jeu Terminé !",
    "Generate Test QR" to "Générer un code QR de test",
    "Generate a test malicious QR code" to "Générer un code QR de test malveillant",
    "Generated on Dec 29, 2025 • 14:32:01 UTC" to "Généré le 29 décembre 2025 • 14:32:01 UTC",
    "Generated on {date} • {time} UTC" to "Généré le {date} • {time} UTC",
    "Generating {format} report..." to "Génération de {format} rapport...",
    "Get Started! 🚀" to "Commencez ! 🚀",
    "GitHub" to "GitHub",
    "GitHub.com is a legitimate developer platform owned by Microsoft. Always verify the exact domain spelling." to "GitHub.com est une plate-forme de développement légitime appartenant à Microsoft. Vérifiez toujours l'orthographe exacte du domaine.",
    "Gmail" to "Gmail",
    "Google Docs" to "Google Docs",
    "Google Docs uses docs.google.com. Always verify the sender knows you before opening shared documents." to "Google Docs utilise docs.google.com. Vérifiez toujours que l'expéditeur vous connaît avant d'ouvrir des documents partagés.",
    "Google services use subdomains of google.com. mail.google.com is the legitimate Gmail address." to "Les services Google utilisent les sous-domaines de google.com. mail.google.com est l'adresse Gmail légitime.",
    "Got it" to "Compris",
    "HIGH" to "ÉLEVÉ",
    "HIGH RISK" to "RISQUE ÉLEVÉ",
    "HIGH RISK DETECTED" to "RISQUE ÉLEVÉ DÉTECTÉ",
    "HTTP instead of HTTPS (no encryption)" to "HTTP au lieu de HTTPS (non cryptage)",
    "HTTPS" to "HTTPS",
    "Help" to "Aide",
    "Heuristic Engine" to "Moteur heuristique",
    "Heuristics" to "Heuristique",
    "Hides the true destination URL from the user" to "Masque la véritable URL de destination à l'utilisateur",
    "High" to "Élevé",
    "High Entropy" to "Entropie élevée",
    "High Risk" to "Risque élevé",
    "High entropy string detected in URL parameters." to "Chaîne à entropie élevée détecté dans les paramètres d'URL.",
    "High-Performance Engine" to "Moteur haute performance",
    "High-Risk TLD" to "TLD à haut risque",
    "High-Risk URL Blocked" to "URL à haut risque bloquée",
    "High-confidence phishing detected. This URL exhibits multiple malicious indicators." to "Phishing à haute confiance détecté. Cette URL présente plusieurs indicateurs malveillants.",
    "Hold steady. Analysed offline in <5ms." to "Tenez bon. Analysé hors ligne en <5 ms.",
    "Home" to "Home",
    "Homograph / IDN Attack" to "Attaque homographe/IDN",
    "Homograph Attack" to "Attaque homographe",
    "Homograph attack: \"c0mmonwealth\" uses zero instead of letter O" to "Attaque homographe : \"c0mmonwealth\" utilise zéro au lieu de la lettre O",
    "Homograph attack: \"paypa1\" uses number 1 instead of letter L" to "Attaque homographe : \"paypa1\" utilise le numéro 1 au lieu de la lettre L",
    "Homograph attacks use similar-looking characters. Always check URLs character by character for suspicious substitutions." to "Attaques homographes utilisez des caractères similaires. Vérifiez toujours les URL caractère par caractère pour détecter les substitutions suspectes.",
    "How aggressive should threat detection be?" to "Dans quelle mesure la détection des menaces doit-elle être agressive ?",
    "Human-Readable Report" to "Rapport lisible par l'homme",
    "I am reporting a suspected phishing URL detected by Mehr Guard:" to "Je signale une URL suspectée de phishing détectée par [[MARQUE]] :",
    "ID: scan_2025_12_29_h9t2" to "ID : scan_2025_12_29_h9t2",
    "ID: {id}" to "ID : {id}",
    "INFO" to "INFO",
    "IP Address Host" to "Adresse IP Hôte",
    "If HTTPS was used, this signal would not trigger and score would drop by ~18 points." to "Si HTTPS était utilisé, ce signal ne se déclencherait pas et le score chuterait d'environ 18 points.",
    "If a registered domain name was used instead of IP address, score would drop by ~28 points." to "Si un nom de domaine enregistré était utilisé à la place d'une adresse IP, le score chuterait d'environ 28 points.",
    "If all characters were ASCII Latin letters, this signal would not trigger and score would drop by ~45 points." to "Si tous les caractères étaient des lettres latines ASCII, ce signal ne se déclencherait pas et le score diminuerait ~45 points.",
    "If no embedded URLs were present in query parameters, score would drop by ~18 points." to "Si aucune URL intégrée n'était présente dans les paramètres de requête, le score chuterait d'environ 18 points.",
    "If only 1-2 subdomains were used, this signal would not trigger. Score would drop by ~12 points." to "Si seulement 1 à 2 sous-domaines étaient utilisés, ce signal ne se déclencherait pas. Le score diminuerait d'environ 12 points.",
    "If the domain spelled the brand correctly without substitutions, score would drop by ~25 points." to "Si le domaine épelait correctement la marque sans substitutions, le score diminuerait d'environ 25 points.",
    "If the domain used only ASCII characters (no IDN), score would drop by ~32 points." to "Si le domaine utilisait uniquement des caractères ASCII (pas d'IDN), le score diminuerait d'environ 32 points.",
    "If the domain used readable words instead of random characters, score would drop by ~12 points." to "Si le domaine utilisait des mots lisibles au lieu de caractères aléatoires, le score diminuerait d'environ 12 points.",
    "If the full destination URL was visible, score would drop by ~18 points (assuming destination is safe)." to "Si l'URL de destination complète était visible, le score diminuerait d'environ 18 points (en supposant que la destination soit sûre).",
    "If this URL used .com, .org, or country TLDs, score would drop by ~25 points." to "Si cette URL utilisait des TLD .com, .org ou nationaux, le score diminuerait d'environ 25 points.",
    "If this were the official brand domain (paypal.com), this signal would not trigger and score would drop by ~35 points." to "S'il s'agissait du domaine officiel de la marque (paypal.com), ce signal ne se déclencherait pas et le score chuterait d'environ 35 points.",
    "Import Image" to "Importer l'image",
    "Imported: {name}" to "Importé : [[PH0]",
    "Incoming Message (+61 491 570 010):" to "Message entrant (+61 491 570 010) :",
    "Incorrect Decision" to "Décision incorrecte",
    "Intermediate Hop" to "Intermédiaire Hop",
    "International domains can hide malicious lookalike characters" to "Les domaines internationaux peuvent masquer des caractères similaires malveillants",
    "Invalid URL Format" to "Format d'URL invalide",
    "Invalid URL format" to "Format d'URL invalide",
    "Invalid theme:" to "Thème invalide :",
    "Isolated Sandbox" to "Bac à sable isolé",
    "It's a Tie!" to "C'est une égalité !",
    "JS" to "JS",
    "JSON format. Best for SIEM integration." to "Format JSON. Idéal pour l'intégration SIEM.",
    "JSON report downloaded" to "Rapport JSON téléchargé",
    "John Smith" to "John Smith",
    "Judge Mode" to "Mode juge",
    "Judge Mode Active" to "Mode juge actif",
    "Judge Mode OFF - Normal detection active" to "Mode juge désactivé - Détection normale active",
    "Judge Mode: Force MALICIOUS results for demo" to "Mode juge : forcer les résultats MALVEILLANTS pour la démo",
    "Judge Mode: ON" to "Mode juge : ON",
    "Just now" to "Tout à l'heure",
    "Kotlin Multiplatform" to "Kotlin Multiplatform",
    "Kotlin engine not ready yet" to "Le moteur Kotlin n'est pas encore prêt",
    "Kotlin/Wasm" to "Kotlin/Wasm",
    "KotlinConf Student Competition 2025-2026" to "Concours étudiant KotlinConf 2025-2026",
    "LIVE" to "LIVE",
    "LIVE FEED ACTIVE" to "LIVE FEED ACTIF",
    "LIVE FEED DISCONNECTED" to "ALIMENTATION EN DIRECT DÉCONNECTÉ",
    "LOW" to "FAIBLE",
    "LOW RISK" to "FAIBLE RISQUE",
    "Language: {language} {flag}" to "Langue : {language} {flag}",
    "Last Update" to "Dernière mise à jour",
    "Latency" to "Latence",
    "Latency: 2ms" to "Latence : 2 ms",
    "Learn about our local architecture" to "Découvrez notre architecture locale",
    "Learn how to identify advanced QR homograph attacks." to "Apprenez à identifier les attaques avancées d'homographes QR.",
    "Legitimate" to "Légitime",
    "Legitimate services use domains; IPs hide identity and bypass filters" to "Les services légitimes utilisent des domaines ; Les adresses IP masquent les filtres d'identité et contournent les filtres",
    "Let's Encrypt (R3)" to "Let's Encrypt (R3)",
    "Light" to "Light",
    "Limited Browser Support" to "Support limité du navigateur",
    "Link copied to clipboard!" to "Lien copié dans le presse-papiers !",
    "LinkedIn" to "LinkedIn",
    "LinkedIn uses linkedin.com as their primary domain. Profile URLs follow the /in/username format." to "LinkedIn utilise linkedin.com comme domaine principal. Les URL de profil suivent le format /in/username.",
    "Live Hint" to "Live Hint",
    "Live Preview" to "Live Preview",
    "Live Scanner" to "Live Scanner",
    "Live Scoreboard" to "Live Scoreboard",
    "Local DB" to "Local DB",
    "Local Database" to "Local Database",
    "Local Memory (RAM)" to "Local Memory (RAM)",
    "Local Privacy" to "Local Confidentialité",
    "Local Sandbox" to "Sandbox local",
    "Local database v2.4.1 active. No data leaves this device." to "Base de données locale v2.4.1 active. Aucune donnée ne quitte cet appareil.",
    "Local storage (history won\\'t persist)" to "Stockage local (l'historique ne persiste pas)",
    "Long URLs can hide malicious parameters or overwhelm users" to "Les URL longues peuvent masquer des paramètres malveillants ou submerger les utilisateurs",
    "Look at the domain carefully. Is \"c0mmonwealth\" spelled correctly? The number 0 is often used to replace the letter O." to "Examinez attentivement le domaine. \"C0mmonwealth\" est-il correctement orthographié ? Le chiffre 0 est souvent utilisé pour remplacer la lettre O.",
    "Look at the domain name carefully. Is \"paypa1\" spelled correctly?" to "Regardez attentivement le nom de domaine. \"paypa1\" est-il correctement orthographié ?",
    "Look closely at the domain structure. Legitimate organisations rarely use hyphens in the main domain name or generic TLDs like" to "Regardez attentivement la structure du domaine. Les organisations légitimes utilisent rarement des traits d'union dans le nom de domaine principal ou dans les TLD génériques comme",
    "Low" to "Faible",
    "Low Risk" to "Faible risque",
    "Low Sensitivity Mode" to "Mode de sensibilité faible",
    "MALICIOUS" to "MALICIOUS",
    "MEDIUM" to "MOYEN",
    "MEDIUM RISK" to "RISQUE MOYEN",
    "MINOR CONCERNS" to "MINEUR PRÉOCCUPATIONS",
    "Machine-Readable" to "Lisible par machine",
    "Make your decision" to "Prenez votre décision",
    "Malicious" to "Malicieux",
    "Manage privacy controls, sensitivity, and security lists." to "Gérez les contrôles de confidentialité, la sensibilité et les listes de sécurité.",
    "Matched 3 signatures in local phishing DB." to "Correspondance à 3 signatures dans la base de données de phishing locale.",
    "Maximum protection. Blocks any suspicious patterns including newly registered domains, uncommon TLDs, and any URL with potential encoding tricks." to "Protection maximale. Bloque tous les modèles suspects, y compris les domaines nouvellement enregistrés, les TLD peu courants et toute URL présentant des astuces d'encodage potentielles.",
    "Medium" to "Moyen",
    "Microsoft-owned platform" to "Plateforme appartenant à Microsoft",
    "Missing features:" to "Fonctionnalités manquantes :",
    "More than 3 subdomain levels (secure.login.paypal.fake.com)" to "Plus de 3 niveaux de sous-domaines (secure.login.paypal.fake.com)",
    "Need help? Visit our GitHub for documentation" to "Besoin d'aide ? Visitez notre GitHub pour la documentation",
    "Never trust shortened URLs from unknown sources. Use URL expander tools to see the real destination before clicking." to "Ne faites jamais confiance aux URL raccourcies provenant de sources inconnues. Utilisez les outils d'extension d'URL pour voir la destination réelle avant de cliquer.",
    "Newly Registered Domain" to "Domaine nouvellement enregistré",
    "Next Round" to "Prochain tour",
    "Next →" to "Suivant →",
    "No Cloud Logs" to "Aucun journal cloud",
    "No HTTPS Encryption" to "Aucun cryptage HTTPS",
    "No HTTPS encryption" to "Aucun cryptage HTTPS",
    "No QR code found in image" to "Aucun code QR trouvé dans image",
    "No URL to copy" to "Aucune URL à copier",
    "No URL to open" to "Aucune URL à ouvrir",
    "No URL to report - analyze one first" to "Aucune URL à signaler - analyser une en premier",
    "No camera found" to "Aucune caméra trouvée",
    "No custom domains blocked." to "Aucun domaine personnalisé bloqué.",
    "No data leaves device" to "Aucune donnée ne quitte l'appareil",
    "No new notifications" to "Aucune nouvelle notification",
    "No recent analysis to view" to "Aucune analyse récente à view",
    "No recent scans" to "Aucune analyse récente",
    "No security threats were detected. The QR code leads to a verified safe destination." to "Aucune menace de sécurité n'a été détectée. Le code QR mène à une destination sûre vérifiée.",
    "No threats detected" to "Aucune menace détectée",
    "None" to "Aucune",
    "Not a valid URL" to "URL non valide",
    "Not found in 52 local offline threat databases." to "Introuvable dans 52 bases de données locales de menaces hors ligne.",
    "Not the official PayPal domain (paypal.com)" to "Pas le domaine PayPal officiel (paypal.com)",
    "Notifications" to "Notifications",
    "Obfuscated JavaScript" to "Obscurci JavaScript",
    "Obfuscated Script" to "Script masqué",
    "Official LinkedIn domain" to "Domaine officiel LinkedIn",
    "Official postal services use their primary domain (auspost.com.au) for all tracking. Verify by visiting the official website directly." to "Les services postaux officiels utilisent leur domaine principal (auspost.com.au) pour tout suivi. Vérifiez en visitant directement le site officiel.",
    "Offline" to "Hors ligne",
    "Offline Core v2.4" to "Offline Core v2.4",
    "Offline Engine V.2.4" to "Offline Engine V.2.4",
    "Offline Guarantee:" to "Garantie hors ligne :",
    "Offline Mode" to "Mode hors ligne",
    "Offline Mode Active" to "Mode hors ligne actif",
    "Offline Privacy" to "Confidentialité hors ligne",
    "Offline Protection" to "Protection hors ligne",
    "Offline Ready" to "Prêt hors ligne",
    "Offline Security" to "Sécurité hors ligne",
    "Offline-First Architecture" to "Architecture hors ligne d'abord",
    "On-Device DB" to "Base de données sur l'appareil",
    "On-Device Database" to "Base de données sur l'appareil",
    "Onboarding" to "Intégration",
    "Only blocks known malicious URLs from the threat database. Minimal false positives, but may miss novel attacks." to "Bloque uniquement les URL malveillantes connues de la base de données des menaces. Faux positifs minimes, mais peuvent manquer de nouvelles attaques.",
    "Open Safely (Sandbox)" to "Ouvrir en toute sécurité (bac à sable)",
    "Open Source Licenses" to "Licences Open Source",
    "Opening PhishTank..." to "Ouverture de PhishTank...",
    "Opening URL in new tab" to "Ouverture de l'URL dans un nouvel onglet",
    "Opening email client..." to "Ouverture du client de messagerie...",
    "Optimised for desktop environments. Scans are processed in under 5ms using native Kotlin Multiplatform binaries." to "Optimisé pour les environnements de bureau. Les analyses sont traitées en moins de 5 ms à l'aide des binaires natifs Kotlin Multiplatform.",
    "Overview" to "Aperçu",
    "PASS" to "PASSER",
    "PDF format. Best for sharing with stakeholders." to "Format PDF. Idéal pour partager avec les parties prenantes.",
    "PDF report ready for download" to "Rapport PDF prêt à télécharger",
    "PHISH" to "PHISH",
    "PHISHING" to "PHISHING",
    "PROCEED WITH CAUTION" to "PROCÉDER AVEC PRUDENCE",
    "Paranoia" to "Paranoïa",
    "Paranoia Mode" to "Mode Paranoïa",
    "Paste URL" to "Coller l'URL",
    "Paste URL to Analyze" to "Coller l'URL à analyser",
    "PayPal Security" to "Sécurité PayPal",
    "Permissive" to "Permissif",
    "Phishing" to "Phishing",
    "Phishing Attempt" to "Tentative de phishing",
    "Phishing Detection Sensitivity" to "Sensibilité de la détection du phishing",
    "Phishing Engine" to "Moteur de phishing",
    "Phishing Report: {url}" to "Rapport d'hameçonnage : {url}",
    "Phishing detection is running normally" to "La détection du phishing fonctionne normalement",
    "Play Again" to "Rejouer",
    "Play Now" to "Jouez maintenant",
    "Play sound when threat detected" to "Jouer du son lorsqu'une menace est détectée",
    "Please drop an image file" to "Veuillez déposer un fichier image",
    "Please enter a URL" to "Veuillez saisir une URL",
    "Please enter a domain" to "Veuillez entrer un domaine",
    "Please enter a valid domain" to "Veuillez entrer un domaine valide",
    "Please select an image" to "Veuillez sélectionner une image",
    "Point your camera at a QR code to detect" to "Pointez votre appareil photo vers un code QR pour le détecter",
    "Points" to "Points",
    "Press Cmd/Ctrl+V again to paste" to "Appuyez à nouveau sur Cmd/Ctrl+V pour coller",
    "Privacy Controls" to "Contrôles de confidentialité",
    "Privacy Policy" to "politique de confidentialité",
    "Privacy Settings" to "Paramètres de confidentialité",
    "Privacy policy: 100% offline, zero data collection" to "Politique de confidentialité : 100 % hors ligne, aucune collecte de données",
    "Proceed with Caution" to "Procédez avec prudence",
    "Processing Env" to "Environnement de traitement",
    "Processing image..." to "Traitement de l'image...",
    "Profile" to "Profil",
    "Profile updated successfully!" to "Profil mis à jour avec succès !",
    "Punycode Domain" to "Domaine Punycode",
    "QR Code Detected!" to "Code QR détecté !",
    "QR Code Scan" to "Numérisation de codes QR",
    "QR Code detected!" to "QR Code détecté !",
    "Mehr Guard" to "[[MARQUE]]",
    "Mehr Guard - Beat the Bot" to "[[MARQUE]] - Battez le robot",
    "Mehr Guard - Dashboard" to "[[MARQUE]] - Tableau de bord",
    "Mehr Guard - Offline Privacy Onboarding" to "[[MARQUE]] - Intégration de la confidentialité hors ligne",
    "Mehr Guard - Scan Dashboard" to "[[MARQUE]] - Tableau de bord de numérisation",
    "Mehr Guard - Scan Result" to "[[MARQUE]] - Résultat de l'analyse",
    "Mehr Guard - Trust Centre" to "[[MARQUE]] - Centre de confidentialité",
    "Mehr Guard Logo" to "Logo [[MARQUE]]",
    "Mehr Guard Results" to "[[MARQUE]] Résultats",
    "Mehr Guard Scan Result" to "[[MARQUE]] Résultat de l'analyse",
    "Mehr Guard Security Audit" to "[[MARQUE]] Audit de sécurité",
    "Mehr Guard Threat Analysis Report" to "[[MARQUE]] Rapport d'analyse des menaces",
    "Mehr Guard Threat Report" to "[[MARQUE]] Rapport sur les menaces",
    "Mehr Guard Verdict: {verdict}" to "[[MARQUE]] Verdict : {verdict}",
    "Mehr Guard analyses potential threats directly on your hardware. Experience" to "Mehr Guard analyse les menaces potentielles directement sur votre matériel. Expérience",
    "Mehr Guard explains" to "[[MARQUE]] explique",
    "Mehr Guard needs camera access to scan QR codes in real-time." to "Mehr Guard a besoin d'un accès à la caméra pour scanner les codes QR en temps réel.",
    "Mehr Guard processes every scan within a secure, isolated local sandbox. We prioritize explainable security with zero cloud telemetry for image analysis." to "Mehr Guard traite chaque analyse dans un bac à sable local sécurisé et isolé. Nous accordons la priorité à une sécurité explicable avec une télémétrie cloud nulle pour l'analyse des images.",
    "Mehr Guard strictly disables all outgoing telemetry. Your scan results, URL history, and image hashes never leave your device." to "Mehr Guard désactive strictement toute télémétrie sortante. Les résultats de votre analyse, votre historique d'URL et vos hachages d'images ne quittent jamais votre appareil.",
    "Mehr Guard uses local heuristic analysis engines. No image data, URL strings, or metadata leaves this device during scanning. Your privacy is mathematically guaranteed." to "Mehr Guard utilise des moteurs d'analyse heuristique locaux. Aucune donnée d'image, chaîne d'URL ou métadonnée ne quitte cet appareil pendant la numérisation. Votre vie privée est mathématiquement garantie.",
    "Mehr Guard works 100% offline! All analysis is done locally on your device. No internet connection required." to "Mehr Guard fonctionne 100 % hors ligne ! Toutes les analyses sont effectuées localement sur votre appareil. Aucune connexion Internet requise.",
    "Mehr Guard | Premium Web Scanner" to "[[MARQUE]] | Scanner Web haut de gamme",
    "Mehr Guard Bot" to "Bot Mehr Guard",
    "Quarantine in Sandbox" to "Quarantaine dans le bac à sable",
    "Quarantined in secure sandbox for analysis" to "Mis en quarantaine dans un bac à sable sécurisé pour analyse",
    "READY" to "PRÊT",
    "Randomly generated domains are often temporary phishing sites" to "Les domaines générés aléatoirement sont souvent des sites de phishing temporaires",
    "Raw Image Buffer" to "Tampon d’image brute",
    "Read Only" to "Lecture seule",
    "Real-Time Scanning" to "Analyse en temps réel",
    "Real-time scanning" to "Analyse en temps réel",
    "Recent Scans" to "Analyses récentes",
    "Recommended Actions" to "Actions recommandées",
    "Refresh Page" to "Actualiser la page",
    "Removed {domain} from {list}" to "Suppression de {domain} de {list}",
    "Removing or changing the suspicious pattern would reduce the overall risk score." to "La suppression ou la modification du modèle suspect réduirait le score de risque global.",
    "Report Export - Mehr Guard" to "Exportation du rapport - [[MARQUE]]",
    "Report Generation" to "Génération de rapports",
    "Report Incorrect Verdict" to "Signaler un verdict incorrect",
    "Report Phishing" to "Signaler un hameçonnage",
    "Report URL copied to clipboard" to "URL du rapport copiée dans le presse-papiers",
    "Report copied to clipboard" to "Rapport copié dans le presse-papiers",
    "Report if this verdict is wrong" to "Signalez si ce verdict est erroné",
    "Report shared" to "Rapport partagé",
    "Report shared successfully!" to "Rapport partagé avec succès !",
    "Reported: {timestamp}" to "Signalé : {timestamp}",
    "Reports" to "Rapports",
    "Reset Defaults" to "Réinitialiser les paramètres par défaut",
    "Reset all Trust Centre settings to default?" to "Réinitialiser tous les paramètres du Trust Center par défaut ?",
    "Reset all settings to default" to "Réinitialiser tous les paramètres par défaut",
    "Response" to "Réponse",
    "Result" to "Résultat",
    "Result # {id}" to "Résultat n° {id}",
    "Result #8291-A" to "Résultat #8291-A",
    "Result copied to clipboard!" to "Résultat copié dans le presse-papier !",
    "Results Dashboard" to "Tableau de bord des résultats",
    "Return to Dashboard" to "Retour au tableau de bord",
    "Risk Assessment" to "L'évaluation des risques",
    "Risk Score" to "Score de risque",
    "Risk Score: {score}/100" to "Score de risque : {score}/100",
    "Risk impact:" to "Impact du risque :",
    "Round" to "Rond",
    "SAFE" to "SÛR",
    "SAFE TO VISIT" to "À VISITER EN SÉCURITÉ",
    "SMS from unknown number impersonating AusPost" to "SMS provenant d'un numéro inconnu usurpant l'identité d'AusPost",
    "SSL Certificate Issues" to "Problèmes de certificat SSL",
    "SUSPICIOUS" to "SUSPECT",
    "SUSPICIOUS ACTIVITY" to "ACTIVITÉ SUSPECTE",
    "Safe" to "Sûr",
    "Safe Scans" to "Analyses sécurisées",
    "Safe to Visit" to "Visite sécuritaire",
    "Safe vs Risky QR Codes" to "Codes QR sûrs ou risqués",
    "Safety Score" to "Score de sécurité",
    "Save & Continue" to "Enregistrer et continuer",
    "Scan" to "Balayage",
    "Scan # {id}" to "Numérisation # {id}",
    "Scan #8021-AF" to "Numérisation n° 8021-AF",
    "Scan Another" to "Scanner un autre",
    "Scan Complete" to "Analyse terminée",
    "Scan History" to "Historique des analyses",
    "Scan Meta" to "Analyser la méta",
    "Scan Monitor" to "Moniteur de numérisation",
    "Scan New QR" to "Scanner un nouveau QR",
    "Scan QR" to "Scanner le QR",
    "Scan QR Code" to "Scanner le code QR",
    "Scan QR codes as they're detected" to "Scannez les codes QR dès qu'ils sont détectés",
    "Scan Time" to "Temps de numérisation",
    "Scan URLs Safely" to "Scannez les URL en toute sécurité",
    "Scan history cleared" to "Historique d'analyse effacé",
    "Scan this QR code with Mehr Guard to see malicious URL detection:" to "Scannez ce code QR avec Mehr Guard pour voir la détection d'URL malveillantes :",
    "Scanned with Mehr Guard - {url}" to "Numérisé avec Mehr Guard - {url}",
    "Scanner Dashboard" to "Tableau de bord du scanner",
    "Scanning..." to "Balayage...",
    "Scans" to "Analyses",
    "Scans for known malicious patterns and heuristic mismatches. Blocks homoglyph attacks and redirect chains. Low false positive rate expected." to "Analyse les modèles malveillants connus et les inadéquations heuristiques. Bloque les attaques d'homoglyphes et les chaînes de redirection. Faible taux de faux positifs attendu.",
    "Secure Environment" to "Environnement sécurisé",
    "Secure. Offline." to "Sécurisé. Hors ligne.",
    "Security" to "Sécurité",
    "Security Analyst" to "Analyste de sécurité",
    "Security Audit: PASS" to "Audit de sécurité : RÉUSSITE",
    "Security Engine Active" to "Moteur de sécurité actif",
    "Security Heuristics" to "Heuristique de sécurité",
    "Security Settings" to "Paramètres de sécurité",
    "Security audit report downloaded" to "Rapport d'audit de sécurité téléchargé",
    "See Results" to "Voir les résultats",
    "See the difference instantly:" to "Voyez instantanément la différence :",
    "Sensitivity Level" to "Niveau de sensibilité",
    "Sensitivity set to {level}" to "Sensibilité réglée sur {level}",
    "Session ID: #GAME-" to "ID de session : #GAME-",
    "Settings" to "Paramètres",
    "Settings are saved automatically and sync across sessions." to "Les paramètres sont enregistrés automatiquement et synchronisés entre les sessions.",
    "Settings reset to default" to "Paramètres réinitialisés aux valeurs par défaut",
    "Settings reset to defaults" to "Paramètres réinitialisés aux valeurs par défaut",
    "Settings saved! Your data stays on-device." to "Paramètres enregistrés ! Vos données restent sur l'appareil.",
    "Share" to "Partager",
    "Share Report" to "Partager le rapport",
    "Share detection stats to improve ML." to "Partagez les statistiques de détection pour améliorer le ML.",
    "Shared successfully!" to "Partagé avec succès !",
    "Sharing not supported" to "Partage non pris en charge",
    "Short URLs hide the actual destination. Prize claims from unknown numbers are almost always scams." to "Les URL courtes masquent la destination réelle. Les réclamations de prix provenant de numéros inconnus sont presque toujours des escroqueries.",
    "Shortened URL hides true destination" to "L'URL raccourcie cache la véritable destination",
    "Show Confidence Score" to "Afficher le score de confiance",
    "Show visual alerts for threats" to "Afficher des alertes visuelles pour les menaces",
    "Sign in to your GitHub account to access your repositories." to "Connectez-vous à votre compte GitHub pour accéder à vos référentiels.",
    "Signatures" to "Signature",
    "Skip" to "Sauter",
    "Some features may not work in your browser." to "Certaines fonctionnalités peuvent ne pas fonctionner dans votre navigateur.",
    "Some minor security concerns were identified. The link appears mostly safe but review recommended." to "Quelques problèmes mineurs de sécurité ont été identifiés. Le lien semble généralement sûr, mais son examen est recommandé.",
    "Some suspicious indicators detected. Verify the source before entering sensitive information." to "Quelques indicateurs suspects détectés. Vérifiez la source avant de saisir des informations sensibles.",
    "Sound Alerts" to "Alertes sonores",
    "Sound alerts" to "Alertes sonores",
    "Source" to "Source",
    "Standard Gmail URL structure" to "Structure d'URL Gmail standard",
    "Standard Google Docs URL format" to "Format d'URL standard de Google Docs",
    "Standard profile URL structure" to "Structure d'URL de profil standard",
    "Status" to "Statut",
    "Streak:" to "Traînée:",
    "Strict" to "Strict",
    "Strict Offline Guarantee" to "Garantie hors ligne stricte",
    "Strict Offline Mode" to "Mode hors ligne strict",
    "Strict Offline Mode disabled" to "Mode hors ligne strict désactivé",
    "Strict Offline Mode enabled" to "Mode hors ligne strict activé",
    "Subdomain \"signin\" used for deception" to "Sous-domaine « connexion » utilisé à des fins de tromperie",
    "Subdomain of google.com" to "Sous-domaine de google.com",
    "Subdomain of google.com (trusted)" to "Sous-domaine de google.com (de confiance)",
    "Submitted via Mehr Guard" to "Soumis via [[MARQUE]]",
    "Success!" to "Succès!",
    "Support" to "Soutien",
    "Suspicious" to "Suspect",
    "Suspicious Redirect Chain" to "Chaîne de redirection suspecte",
    "Suspicious TLD" to "TLD suspect",
    "Suspicious TLD (.tk)" to "TLD suspect (.tk)",
    "Switch Language: English/Deutsch" to "Langue de commutation : anglais/allemand",
    "Switched to {mode} mode" to "Passé en mode {mode}",
    "System Health" to "Santé du système",
    "System Secure" to "Système sécurisé",
    "System Status" to "État du système",
    "Systems Operational" to "Systèmes opérationnels",
    "TLD" to "TLD",
    "Target IP is located in a high-risk ASN." to "L’adresse IP cible est située dans un ASN à haut risque.",
    "Target URL" to "URL cible",
    "Technical Indicators" to "Indicateurs techniques",
    "Technical Indicators:" to "Indicateurs techniques :",
    "Terms" to "Termes",
    "Test QR Code" to "Tester le code QR",
    "Thank you! Feedback recorded: Should be {verdict}" to "Merci! Commentaires enregistrés : doit être {verdict}",
    "The Kotlin/JS analysis engine is still loading or failed to initialize." to "Le moteur d'analyse Kotlin/JS est toujours en cours de chargement ou n'a pas réussi à s'initialiser.",
    "The bot was faster this time. Try again!" to "Le robot était plus rapide cette fois. Essayer à nouveau!",
    "The destination URL employs" to "L'URL de destination utilise",
    "The domain uses the Cyrillic 'а' (U+0430) instead of Latin 'a' (U+0061)." to "Le domaine utilise le cyrillique « а » (U+0430) au lieu du latin « a » (U+0061).",
    "The domain uses the Cyrillic 'а' (U+0430) instead of Latin 'a' (U+0061). This technique is commonly used to trick users into believing they are visiting a legitimate service." to "Le domaine utilise le cyrillique « а » (U+0430) au lieu du latin « a » (U+0061). Cette technique est couramment utilisée pour faire croire aux utilisateurs qu’ils visitent un service légitime.",
    "The entire threat signature database (100,000+ patterns) is stored locally for millisecond lookups without any network requests." to "L'intégralité de la base de données de signatures de menaces (plus de 100 000 modèles) est stockée localement pour des recherches en millisecondes sans aucune requête réseau.",
    "The entire threat signature database is downloaded to your device for millisecond lookups." to "L'intégralité de la base de données des signatures de menaces est téléchargée sur votre appareil pour des recherches en millisecondes.",
    "The image doesn\\'t contain a recognizable QR code, or it may be damaged." to "L'image ne contient pas de code QR reconnaissable ou elle peut être endommagée.",
    "The input doesn\\'t appear to be a valid URL." to "L'entrée ne semble pas être une URL valide.",
    "The number 1 and lowercase L look identical in many fonts. Always verify paypal.com directly." to "Le chiffre 1 et le L minuscule semblent identiques dans de nombreuses polices. Vérifiez toujours paypal.com directement.",
    "The pattern matches known phishing characteristics" to "Le modèle correspond à des caractéristiques de phishing connues",
    "The scanned QR code contains malicious indicators associated with phishing and credential harvesting. Do not proceed to the target URL." to "Le code QR scanné contient des indicateurs malveillants associés au phishing et à la collecte d'informations d'identification. Ne passez pas à l’URL cible.",
    "The scanned QR code shows suspicious patterns that may indicate potential security risks. Proceed with caution." to "Le code QR numérisé présente des modèles suspects pouvant indiquer des risques de sécurité potentiels. Procédez avec prudence.",
    "Think you can outsmart our AI? Try to craft a phishing URL that fools the detector!" to "Vous pensez pouvoir déjouer notre IA ? Essayez de créer une URL de phishing qui trompe le détecteur !",
    "This URL passed all {count} security checks" to "Cette URL a réussi tous les contrôles de sécurité de {count}",
    "This URL triggered a security check" to "Cette URL a déclenché un contrôle de sécurité",
    "This URL was flagged by Mehr Guard\\'s offline phishing detection engine." to "Cette URL a été signalée par le moteur de détection de phishing hors ligne de Mehr Guard\\.",
    "This image was analysed locally on your device. No data was sent to the cloud for this verdict." to "Cette image a été analysée localement sur votre appareil. Aucune donnée n'a été envoyée vers le cloud pour ce verdict.",
    "This is a Google subdomain - check if it\\'s the legitimate Gmail service." to "Il s'agit d'un sous-domaine Google : vérifiez s'il s'agit du service Gmail légitime.",
    "This is a security feature — your URLs never leave your device." to "Il s'agit d'une fonctionnalité de sécurité : vos URL ne quittent jamais votre appareil.",
    "This is a well-established software company domain." to "Il s’agit d’un domaine d’éditeur de logiciels bien établi.",
    "This is the official LinkedIn domain for professional networking." to "Il s'agit du domaine LinkedIn officiel pour le réseautage professionnel.",
    "This may happen if: • You're using a very old browser • JavaScript is disabled • The page didn't fully load Try refreshing the page. If the issue persists, try Chrome, Firefox, or Safari." to "Cela peut se produire si : • Vous utilisez un très ancien navigateur • JavaScript est désactivé • La page ne s'est pas complètement chargée Essayez d'actualiser la page. Si le problème persiste, essayez Chrome, Firefox ou Safari.",
    "This was actually {label}." to "Il s'agissait en fait de {label}.",
    "This was {label}." to "C'était {label}.",
    "Threat Alerts" to "Alertes de menace",
    "Threat Analysis" to "Analyse des menaces",
    "Threat Analysis Report" to "Rapport d'analyse des menaces",
    "Threat Confidence" to "Confiance face aux menaces",
    "Threat Database" to "Base de données des menaces",
    "Threat Detected" to "Menace détectée",
    "Threat Verdict" to "Verdict de menace",
    "Threat alerts" to "Alertes de menace",
    "Threat blocked and reported" to "Menace bloquée et signalée",
    "Threat database is up to date" to "La base de données des menaces est à jour",
    "Threat signatures updated to v2.4.1" to "Signatures de menaces mises à jour vers la version 2.4.1",
    "Threats" to "Menaces",
    "Time" to "Temps",
    "Tips for better scanning: • Ensure good lighting • Hold the camera steady • Fill the frame with the QR code • Avoid glare or reflections • Try uploading a clearer image" to "Conseils pour une meilleure numérisation : • Assurez un bon éclairage • Maintenez l'appareil photo stable • Remplissez le cadre avec le code QR • Évitez l'éblouissement ou les reflets • Essayez de télécharger une image plus claire",
    "Today, 04:00 AM" to "Aujourd'hui, 04h00",
    "Today, 14:32:05" to "Aujourd'hui, 14:32:05",
    "Today, {time}" to "Aujourd'hui, {time}",
    "Toggle Judge Mode" to "Activer/Désactiver le mode Juge",
    "Toggle Language" to "Changer de langue",
    "Toggle Theme" to "Basculer le thème",
    "Toggle light/dark mode" to "Basculer en mode clair/sombre",
    "Toggle menu" to "Basculer le menu",
    "Toggle theme" to "Changer de thème",
    "Top 100 Alexa Rank - whitelisted" to "Top 100 Alexa Rank - liste blanche",
    "Top 1k Alexa Rank whitelisted offline." to "Top 1k Alexa Rank sur liste blanche hors ligne.",
    "Top Analysis Factors" to "Principaux facteurs d'analyse",
    "Torch" to "Torche",
    "Torch error" to "Erreur de torche",
    "Torch not available" to "Torche non disponible",
    "Torch off" to "Torche éteinte",
    "Torch on" to "Torche allumée",
    "Training" to "Entraînement",
    "Training Centre" to "Centre de formation",
    "Trust Centre" to "Centre de confiance",
    "Try Again" to "Essayer à nouveau",
    "Try It Now!" to "Essayez-le maintenant !",
    "Typosquatting" to "Typosquattage",
    "Typosquatting Detected" to "Typosquattage détecté",
    "Typosquatting pattern detected" to "Modèle de typosquatting détecté",
    "UNKNOWN" to "INCONNU",
    "URL" to "URL",
    "URL Shortener" to "Raccourcisseur d'URL",
    "URL Shortener Detected" to "Raccourcisseur d'URL détecté",
    "URL contains Cyrillic, Greek, or other lookalike Unicode characters" to "L'URL contient des caractères cyrilliques, grecs ou autres caractères Unicode similaires.",
    "URL contains another URL in query parameters" to "L'URL contient une autre URL dans les paramètres de requête",
    "URL copied to clipboard!" to "URL copiée dans le presse-papier !",
    "URL exceeds 100 characters" to "L'URL dépasse 100 caractères",
    "URL parsing (please update your browser)" to "Analyse d'URL (veuillez mettre à jour votre navigateur)",
    "URL pasted - press Enter to analyze" to "URL collée - appuyez sur Entrée pour analyser",
    "URL path contains /login, /signin, /verify, /secure, /account" to "Le chemin de l'URL contient /login, /signin, /verify, /secure, /account",
    "URL to analyze" to "URL à analyser",
    "URL uses raw IP address instead of domain name" to "L'URL utilise l'adresse IP brute au lieu du nom de domaine",
    "URL:" to "URL :",
    "URL: {url}" to "URL : {url}",
    "URL: {url}\\nVerdict: {verdict}\\nConfidence: {confidence}%" to "URL : {url}\\nVerdict : {verdict}\\nConfiance : {confidence}%",
    "URLs are risky!" to "Les URL sont risquées !",
    "Unable to determine verdict. Please try again." to "Impossible de déterminer le verdict. Veuillez réessayer.",
    "Unknown" to "Inconnu",
    "Unknown URL" to "URL inconnue",
    "Unknown Verdict" to "Verdict inconnu",
    "Unknown sender number" to "Numéro d'expéditeur inconnu",
    "Unsolicited prize notification" to "Notification de prix non sollicitée",
    "Upload" to "Télécharger",
    "Upload Image" to "Télécharger une image",
    "Upload Image Instead" to "Téléchargez plutôt une image",
    "Urgency tactics in message" to "Tactiques d'urgence dans le message",
    "Use condensed layout for results" to "Utiliser une mise en page condensée pour les résultats",
    "Users may not notice subtle character swaps like \"1\" for \"l\" or \"0\" for \"o\"" to "Les utilisateurs peuvent ne pas remarquer des échanges de caractères subtils comme \"1\" pour \"l\" ou \"0\" pour \"o\".",
    "Uses bit.ly, t.co, tinyurl, or similar shortening service" to "Utilise bit.ly, t.co, tinyurl ou un service de raccourcissement similaire",
    "Uses high-risk TLDs like .tk, .ml, .ga, .cf, .xyz" to "Utilise des TLD à haut risque comme .tk, .ml, .ga, .cf, .xyz",
    "VERIFIED SAFE" to "SÉCURISÉ VÉRIFIÉ",
    "VS" to "CONTRE",
    "VS MODE" to "MODE CONTRE",
    "Valid Extended Validation certificate" to "Certificat de validation étendue valide",
    "Valid Google certificate" to "Certificat Google valide",
    "Valid SSL Certificate" to "Certificat SSL valide",
    "Verdict" to "Verdict",
    "Verdict: {verdict}" to "Verdict : {verdict}",
    "VerdictPhish" to "VerdictPhish",
    "VerdictSafe" to "VerdictSûr",
    "VerdictWarn" to "VerdictAvertir",
    "Verified by Mehr Guard Enterprise" to "Vérifié par Mehr Guard Enterprise",
    "Verified by Mehr Guard Enterprise v{version}" to "Vérifié par Mehr Guard Enterprise v{version}",
    "Verified by local heuristics v2.4. No phishing patterns, obfuscated scripts, or blacklist matches found." to "Vérifié par l'heuristique locale v2.4. Aucun modèle de phishing, aucun script obscurci ou aucune correspondance sur liste noire n'a été trouvé.",
    "Verifying..." to "Vérification...",
    "Version" to "Version",
    "Very High" to "Très élevé",
    "View All" to "Tout afficher",
    "View Full History" to "Voir l'historique complet",
    "View Full Report" to "Voir le rapport complet",
    "View John Smith\\'s professional profile on LinkedIn." to "Voir le profil professionnel de John Smith sur LinkedIn.",
    "View Security Audit" to "Voir l'audit de sécurité",
    "View detailed analysis in dashboard" to "Voir l'analyse détaillée dans le tableau de bord",
    "Visual Appearance (What user sees)" to "Aspect visuel (ce que l'utilisateur voit)",
    "WARN" to "WARN",
    "Warning" to "Avertissement",
    "We detect multiple attack types:" to "Nous détectons plusieurs attaques types :",
    "We strictly disable outgoing telemetry for scans. Scan results and image hashes remain local." to "Nous désactivons strictement la télémétrie sortante pour les analyses. Les résultats de l'analyse et les hachages d'images restent locaux.",
    "Welcome to Jira - project tracking for agile teams." to "Bienvenue dans Jira - suivi de projet pour les équipes agiles.",
    "Welcome to Mehr Guard" to "Bienvenue dans [[MARQUE]]",
    "What it checks:" to "Ce qu'il vérifie :",
    "Why it matters:" to "Pourquoi est-ce important :",
    "Why the bot flagged it" to "Pourquoi le robot l'a signalé",
    "Why this verdict?" to "Pourquoi cela verdict ?",
    "Without other risk signals, login paths on safe domains would not increase score significantly." to "Sans autres signaux de risque, les chemins de connexion sur des domaines sécurisés n'augmenteraient pas le score de manière significative.",
    "Works 100% offline!" to "Fonctionne à 100 % hors ligne !",
    "Workspace / Security / Reports" to "Espace de travail / Sécurité / Rapports",
    "Would you like to report this URL?\\n\\nOptions:\\n1. PhishTank - Click OK to open submission page\\n2. Email - Click Cancel to compose email\\n\\nURL: {url}" to "Voulez-vous signaler cette URL ?\\n\\nOptions :\\n1. PhishTank - Cliquez sur OK pour ouvrir la page de soumission\\n2. E-mail - Cliquez sur Annuler pour rédiger l'e-mail\\n\\nURL : {url}",
    "Wrong Verdict?" to "Mauvais verdict ?",
    "Wrong!" to "Faux !",
    "Yesterday" to "Hier",
    "You" to "Vous",
    "You can still use Mehr Guard by uploading images or pasting URLs directly." to "Vous pouvez toujours utiliser [[MARQUE]] en téléchargeant des images ou en collant directement des URL.",
    "You can still use Mehr Guard: • Upload QR code images • Paste URLs directly • Use the sample URLs provided" to "Vous pouvez toujours utiliser [[MARQUE]] : • Téléchargez des images de code QR. • Collez directement les URL. • Utilisez les exemples d'URL fournis.",
    "You correctly identified this as {label}." to "Vous avez correctement identifié cet élément comme étant {label}.",
    "You have 3 unread emails in your inbox." to "Vous avez 3 e-mails non lus dans votre boîte de réception.",
    "You identified the safe URL correctly." to "Vous avez correctement identifié l'URL sécurisée.",
    "You spotted it correctly as {label}!" to "Vous l'avez repéré correctement comme étant {label} !",
    "You spotted the phishing URL correctly." to "Vous avez repéré l'URL de phishing. correctement.",
    "You're offline — analysis still works!" to "Vous êtes hors ligne – l'analyse fonctionne toujours !",
    "You're reporting that this verdict may be wrong:" to "Vous signalez que ce verdict est peut-être erroné :",
    "You\\'re Offline" to "Vous êtes hors ligne",
    "Your Score" to "Votre score",
    "Your browser doesn\\'t support camera access, or you\\'re on a device without a camera." to "Votre navigateur ne prend pas en charge l'accès à la caméra, ou vous êtes sur un appareil sans caméra.",
    "Your data never leaves this device. All processing is local. No tracking, no uploads." to "Vos données ne quittent jamais cet appareil. Tout le traitement est local. Pas de suivi, pas de téléchargement.",
    "Your data stays on-device." to "Vos données restent sur l'appareil.",
    "\\nRisk Score:" to "\\nScore de risque :",
    "a phishing attempt" to "une tentative de phishing",
    "actually legitimate" to "réellement légitime",
    "bit.ly shortener" to "bit.ly shortener",
    "characters often associated with phishing campaigns targeting financial institutions. The domain age is" to "caractères souvent associés aux campagnes de phishing ciblant les institutions financières. L'âge du domaine est",
    "critical" to "critique",
    "danger" to "danger",
    "for core services." to "pour les services de base.",
    "high" to "élevé",
    "homoglyph obfuscation" to "obscurcissement des homoglyphes",
    "in your browser." to "dans votre navigateur.",
    "just now" to "juste maintenant",
    "low" to "faible",
    "malicious" to "malveillant",
    "medium" to "moyen",
    "offline" to "hors ligne",
    "online" to "en ligne",
    "or click \"Upload\" to select a file" to "ou cliquez sur \"Télécharger\" pour sélectionner un fichier",
    "phishing" to "phishing",
    "risk-badge danger" to "risk-badge danger",
    "risk-badge warning" to "risk-badge avertissement",
    "risk-item-expanded severity-" to "élément de risque-gravité étendue-",
    "safe" to "sûr",
    "suspicious" to "suspect",
    "to analyze," to "pour analyser,",
    "to focus," to "pour se concentrer,",
    "to reset" to "pour réinitialiser",
    "unknown" to "inconnu",
    "v2.4.1 •" to "v2.4.1 •",
    "warning" to "avertissement",
    "without compromising data privacy." to "sans compromettre la confidentialité des données.",
    "zero-latency phishing detection" to "détection de phishing sans latence",
    "{date}, {time}" to "{date}, {time}",
    "{days} day ago" to "{days} il y a un jour",
    "{days} days ago" to "{days} jours il y a",
    "{hours} hour ago" to "{hours} heure il y a",
    "{hours} hours ago" to "{hours} heures il y a",
    "{label} disabled" to "{label} désactivé",
    "{label} enabled" to "{label} activé",
    "{level} Confidence" to "{level} Confiance",
    "{minutes} minute ago" to "{minutes} il y a une minute",
    "{minutes} minutes ago" to "{minutes} il y a quelques minutes",
    "{months} month ago" to "{months} mois il y a",
    "{months} months ago" to "{months} il y a mois",
    "{points} pts" to "{points} pts",
    "{title}: {summary}" to "{title} : {summary}",
    "{weeks} week ago" to "{weeks} il y a une semaine",
    "{weeks} weeks ago" to "{weeks} il y a semaines",
    "© 2024 Mehr Guard Security Inc. All rights reserved." to "© 2024 [[MARQUE]] Security Inc. Tous droits réservé.",
    "हिन्दी" to "हिन्दी",
    "⌨️ Tip: Press" to "⌨️ Astuce : Appuyez sur",
    "⚠ Try Phishing URL" to "⚠ Essayez l'URL de phishing",
    "✅ No data leaves your device" to "✅ Aucune donnée ne quitte votre appareil",
    "✅ Same engine as mobile apps" to "✅ Même moteur que les applications mobiles",
    "✅ Works without internet" to "✅ Fonctionne sans Internet",
    "✓ No brand impersonation" to " ✓ Aucune usurpation d'identité de marque ",
    "✓ No homograph attacks" to " ✓ Aucune attaque d'homographe ",
    "✓ No suspicious patterns" to " ✓ Aucun modèle suspect ",
    "✓ Safe TLD" to " ✓ TLD sécurisé ",
    "✓ Try Safe URL" to " ✓ Essayez Safe URL",
    "日本語" to "日本語",
    "简体中文" to "简体中文",
    "🌐 Homograph attacks (Cyrillic chars)" to "🌐 Attaques d'homographes (caractères cyrilliques)",
    "🎉 You Win!" to "🎉 Vous gagnez !",
    "🎬 Demo Mode: Click \"Analyze URL\" to see detection" to "🎬 Mode démo : cliquez sur « Analyser l'URL » pour voir détection",
    "🎮 Craft a sneaky phishing URL..." to "🎮 Créez une URL de phishing sournoise...",
    "🎮 Game Mode: Try to craft a URL that gets detected as SAFE!" to "🎮 Mode de jeu : essayez de créer une URL qui sera détectée comme SÉCURISÉE !",
    "🏆 Players challenged:" to "🏆 Joueurs mis au défi :",
    "🏆 You beat the bot! Score: {score}/{attempts}" to "🏆 Vous avez battu le bot ! Score : {score}/{attempts}",
    "💡 What would reduce this?" to "💡 Qu'est-ce qui réduirait cela ?",
    "🔒 100% offline • Zero data collection • Open source (Apache 2.0)" to "🔒 100 % hors ligne • Zéro collecte de données • Open source (Apache 2.0)",
    "🔒 Zero data collection • 🚀 Same engine as Android & iOS • 🧠 Ensemble ML (25+ heuristics)" to "🔒 Zéro collecte de données • 🚀 Même moteur qu'Android et iOS • 🧠 Ensemble ML (25+ heuristiques)",
    "🔗 URL shortener obfuscation" to "🔗 Obfuscation du raccourcisseur d'URL",
    "🔤 Typosquatting (paypa1 → paypal)" to "🔤 Typosquatting (paypa1 → paypal)",
    "🛡️ Mehr Guard Analysis" to "🛡️ [[MARQUE]] Analyse",
    "🛡️ Mehr Guard — Kotlin Multiplatform QRishing Detector" to "🛡️ [[MARQUE]] — Détecteur QRishing multiplateforme Kotlin",
    "🤖 Bot wins! Phishing detected. Score: {score}/{attempts}" to "🤖 Le robot gagne ! Phishing détecté. Note : {score}/{attempts}",
    "🧑‍⚖️ Demo: Forced MALICIOUS result" to "🧑‍⚖️ Démo : résultat MALICIEUX forcé",
    "🧑‍⚖️ Judge Mode ON - All URLs will show MALICIOUS" to "🧑‍⚖️ Mode juge activé - Toutes les URL afficheront MALICIOUS",
    "🧑‍⚖️ Judge Mode activated - Demo history loaded!" to "🧑‍⚖️ Mode juge activé - Historique de la démo chargé !",
    "🧪 Try these examples:" to "🧪 Essayez ces exemples :",
    "Added {date}" to "Ajouté le {date}",
    "Analyzing..." to "Analyse...",
    "Camera N/A" to "Caméra indisponible",
    "Error analyzing URL: {error}" to "Erreur lors de l’analyse de l’URL : {error}",
    "Challenge Mehr Guard's offline AI engine. Can you spot phishing URLs faster than the bot?" to "Défiez le moteur IA hors ligne de Mehr Guard. Pouvez-vous repérer les URL de phishing plus vite que le bot ?",
    "Paste URL to analyze (e.g., https://example.com)" to "Collez l’URL à analyser (p. ex., https://example.com)",
    "Mehr Guard Active Scanner - Real-time QR code scanning with AI-powered phishing detection." to "Scanner actif Mehr Guard : analyse en temps réel des codes QR avec détection de phishing alimentée par l’IA.",
    "Mehr Guard Dashboard - Enterprise offline QR code security with explainable threat detection." to "Tableau de bord Mehr Guard : sécurité des codes QR hors ligne pour l’entreprise avec détection des menaces explicable.",
    "Mehr Guard Privacy Settings - 100% offline protection with zero cloud telemetry." to "Paramètres de confidentialité Mehr Guard : protection 100 % hors ligne, zéro télémétrie cloud.",
    "Mehr Guard Report Export - Generate and download threat analysis reports in PDF or JSON format." to "Export de rapports Mehr Guard : générer et télécharger des rapports d’analyse des menaces en PDF ou JSON.",
    "Mehr Guard Threat Analysis - Detailed scan result showing attack breakdown and security recommendations." to "Analyse des menaces Mehr Guard : résultat de scan détaillé avec ventilation des attaques et recommandations de sécurité.",
    "Mehr Guard Trust Centre - Manage privacy controls, detection sensitivity, and security lists." to "Centre de confiance Mehr Guard : gérer les contrôles de confidentialité, la sensibilité de détection et les listes de sécurité.",
    "Mehr Guard Web - AI-powered phishing detection running entirely in your browser. Scan and analyze URLs for security threats." to "Mehr Guard Web : détection de phishing alimentée par l’IA qui s’exécute entièrement dans votre navigateur. Scannez et analysez les URL pour détecter des menaces.",
    "Mehr Guard scan results - AI-powered phishing detection with detailed security analysis." to "Résultats de scan Mehr Guard : détection de phishing par IA avec analyse de sécurité détaillée.",
    "why" to "pourquoi",
    "heuristics" to "heuristiques",
    "redirects" to "redirections",
    "ssl_issuer" to "ssl_émetteur",
    "subdomain_chaining" to "enchaînement_de_sous-domaines",
    "suspicious_tld" to "tld_suspect",
    "threat_type" to "type_de_menace",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "ACTIVITÉ SUSPECTE",
    WebStringKey.VerdictWarning to "Avertissement",
    WebStringKey.VerdictSuspiciousDesc to "Le code QR scanné présente des modèles suspects pouvant indiquer des risques de sécurité potentiels. Procédez avec prudence.",
    WebStringKey.VerdictMinorConcerns to "PRÉOCCUPATIONS MINEURES",
    WebStringKey.VerdictCaution to "Prudence",
    WebStringKey.VerdictMinorConcernsDesc to "Quelques préoccupations de sécurité mineures ont été identifiées. Le lien semble principalement sûr mais une vérification est recommandée.",
    WebStringKey.VerdictVerifiedSafe to "VÉRIFIÉ SÛR",
    WebStringKey.VerdictSafeLabel to "Sûr",
    WebStringKey.VerdictVerifiedSafeDesc to "Aucune menace de sécurité détectée. Le code QR mène à une destination sûre vérifiée.",
    WebStringKey.VerdictNoActivity to "Aucune Activité",
    WebStringKey.VerdictAwaitingScan to "En Attente de Scan",
    WebStringKey.VerdictNoActivityDesc to "Aucune donnée de scan disponible. Veuillez scanner un code QR ou entrer une URL à analyser.",
    WebStringKey.ScanQrToSeeActivity to "Scannez un code QR pour voir votre activité ici",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "Point de Données",
    WebStringKey.ProcessingEnv to "Environnement de Traitement",
    WebStringKey.ExternalTransmission to "Transmission Externe",
    WebStringKey.RawImageBuffer to "Tampon d'Image Brute",
    WebStringKey.LocalMemoryRam to "Mémoire Locale (RAM)",
    WebStringKey.TransmissionNone to "Aucune",
    WebStringKey.DecodedUrlPayload to "URL/Charge Décodée",
    WebStringKey.LocalAnalysis to "Analyse Locale",
    WebStringKey.ThreatVerdictLabel to "Verdict de Menace",
    WebStringKey.LocalDatabase to "Base de Données Locale",
    
    // Reason Code Titles and Descriptions
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "URL JavaScript",
    WebStringKey.ReasonJavascriptUrlDesc to "Schéma d'URL JavaScript détecté - exécute du code au clic",
    WebStringKey.ReasonDataUriTitle to "URI de Données",
    WebStringKey.ReasonDataUriDesc to "Schéma d'URI de données détecté - peut contenir du code malveillant intégré",
    WebStringKey.ReasonAtSymbolInjectionTitle to "Injection du Symbole @",
    WebStringKey.ReasonAtSymbolInjectionDesc to "L'URL contient le symbole @ indiquant une possible tentative de vol d'identifiants",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "Attaque Homographe",
    WebStringKey.ReasonHomographDesc to "Le nom de domaine internationalisé (IDN) peut usurper un autre domaine",
    WebStringKey.ReasonMixedScriptTitle to "Script Mixte",
    WebStringKey.ReasonMixedScriptDesc to "Le nom d'hôte contient des caractères de différents scripts (usurpation possible)",
    WebStringKey.ReasonLookalikeCharsTitle to "Caractères Similaires",
    WebStringKey.ReasonLookalikeCharsDesc to "Le domaine contient des caractères Unicode ressemblant à des lettres ASCII",
    WebStringKey.ReasonZeroWidthCharsTitle to "Caractères de Largeur Nulle",
    WebStringKey.ReasonZeroWidthCharsDesc to "Caractères Unicode cachés de largeur nulle détectés (tentative d'obfuscation)",
    WebStringKey.ReasonIpHostTitle to "Hôte IP",
    WebStringKey.ReasonIpHostDesc to "L'URL utilise une adresse IP au lieu d'un nom de domaine",
    WebStringKey.ReasonCredentialParamTitle to "Paramètre d'Identifiants",
    WebStringKey.ReasonCredentialParamDesc to "L'URL contient des paramètres liés aux identifiants (mot de passe, jeton, etc.)",
    WebStringKey.ReasonBrandImpersonationTitle to "Usurpation de Marque",
    WebStringKey.ReasonBrandImpersonationDesc to "L'URL semble usurper une marque connue",
    WebStringKey.ReasonBrandInSubdomainTitle to "Marque dans le Sous-domaine",
    WebStringKey.ReasonBrandInSubdomainDesc to "Le nom de marque apparaît dans le sous-domaine mais pas dans le domaine principal",
    WebStringKey.ReasonRiskyExtensionTitle to "Extension Risquée",
    WebStringKey.ReasonRiskyExtensionDesc to "Le chemin contient une extension de fichier potentiellement dangereuse",
    WebStringKey.ReasonDoubleExtensionTitle to "Double Extension",
    WebStringKey.ReasonDoubleExtensionDesc to "Double extension de fichier détectée (tactique courante de malware)",
    WebStringKey.ReasonEncodedPayloadTitle to "Charge Encodée",
    WebStringKey.ReasonEncodedPayloadDesc to "Grandes données encodées détectées dans les paramètres d'URL",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP au lieu de HTTPS",
    WebStringKey.ReasonHttpNotHttpsDesc to "L'URL utilise le protocole HTTP non sécurisé au lieu de HTTPS",
    WebStringKey.ReasonSuspiciousTldTitle to "TLD Suspect",
    WebStringKey.ReasonSuspiciousTldDesc to "Domaine de premier niveau fréquemment utilisé pour le phishing",
    WebStringKey.ReasonHighEntropyHostTitle to "Hôte à Haute Entropie",
    WebStringKey.ReasonHighEntropyHostDesc to "Le nom de domaine semble généré aléatoirement",
    WebStringKey.ReasonRedirectParamTitle to "Paramètre de Redirection",
    WebStringKey.ReasonRedirectParamDesc to "L'URL contient un paramètre de redirection pouvant mener à un autre site",
    WebStringKey.ReasonDeepSubdomainTitle to "Sous-domaine Profond",
    WebStringKey.ReasonDeepSubdomainDesc to "Profondeur excessive de sous-domaine (peut masquer le vrai domaine)",
    WebStringKey.ReasonMultiTldTitle to "TLD Multiples",
    WebStringKey.ReasonMultiTldDesc to "Plusieurs segments ressemblant à des TLD dans le nom de domaine",
    WebStringKey.ReasonNumericSubdomainTitle to "Sous-domaine Numérique",
    WebStringKey.ReasonNumericSubdomainDesc to "Sous-domaine uniquement numérique détecté",
    WebStringKey.ReasonNonStandardPortTitle to "Port Non Standard",
    WebStringKey.ReasonNonStandardPortDesc to "L'URL utilise un numéro de port non standard",
    WebStringKey.ReasonSuspiciousPortTitle to "Port Suspect",
    WebStringKey.ReasonSuspiciousPortDesc to "L'URL utilise un port couramment associé aux attaques",
    WebStringKey.ReasonFragmentHidingTitle to "Masquage de Fragment",
    WebStringKey.ReasonFragmentHidingDesc to "Le fragment d'URL semble masquer du contenu supplémentaire",
    WebStringKey.ReasonExcessiveEncodingTitle to "Encodage Excessif",
    WebStringKey.ReasonExcessiveEncodingDesc to "Encodage d'URL excessif détecté (tentative d'obfuscation)",
    WebStringKey.ReasonDomainAgePatternTitle to "Modèle d'Âge de Domaine",
    WebStringKey.ReasonDomainAgePatternDesc to "Le nom de domaine correspond aux modèles de domaines générés automatiquement",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "Raccourcisseur d'URL",
    WebStringKey.ReasonUrlShortenerDesc to "L'URL utilise un service de raccourcissement (masque la destination réelle)",
    WebStringKey.ReasonSuspiciousPathTitle to "Chemin Suspect",
    WebStringKey.ReasonSuspiciousPathDesc to "Le chemin contient des mots-clés suspects (connexion, vérifier, etc.)",
    WebStringKey.ReasonLongUrlTitle to "URL Longue",
    WebStringKey.ReasonLongUrlDesc to "URL inhabituellement longue",
    WebStringKey.ReasonCredentialKeywordsTitle to "Mots-clés d'Identifiants",
    WebStringKey.ReasonCredentialKeywordsDesc to "L'URL contient des mots-clés de collecte d'identifiants",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "URL Non Analysable",
    WebStringKey.ReasonUnparseableDesc to "L'URL n'a pas pu être entièrement analysée",
    WebStringKey.ReasonAnalysisCompleteTitle to "Analyse Terminée",
    WebStringKey.ReasonAnalysisCompleteDesc to "Analyse terminée avec succès",
    
    // ML Score Labels
    WebStringKey.MlPhishingScore to "Score ML de Phishing",
    WebStringKey.MlCharacterAnalysis to "Analyse des caractères",
    WebStringKey.MlFeatureAnalysis to "Analyse des caractéristiques",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "Domaine IDN / Punycode",
    WebStringKey.IdnPunycodeDomainDesc to "Ce domaine utilise des caractères internationalisés. Affichage sécurisé :",
    WebStringKey.MixedScriptAttackTitle to "Attaque Multi-Scripts",
    WebStringKey.MixedScriptAttackDesc to "Le domaine contient des caractères de plusieurs scripts (ex. Cyrillique + Latin). Courant dans les attaques homographes.",
    WebStringKey.ConfusableCharsTitle to "Caractères Confondables",
    WebStringKey.ConfusableCharsDesc to "Le domaine contient des caractères ressemblant à des lettres courantes (ex. 'а' vs 'a')."
)
